var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocCompleted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 221.957,
    height: 215.915,
    viewBox: "0 0 221.957 215.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e02a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be0031"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18855",
    "data-name": "Grupo 18855",
    transform: "translate(-27.839 -34.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(29.02 35.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17946",
    "data-name": "Grupo 17946",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17936",
    "data-name": "Grupo 17936",
    transform: "translate(2.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17935",
    "data-name": "Grupo 17935"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4587",
    "data-name": "Rect\\xE1ngulo 4587",
    width: 60.379,
    height: 99.944,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17938",
    "data-name": "Grupo 17938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17937",
    "data-name": "Grupo 17937"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4588",
    "data-name": "Rect\\xE1ngulo 4588",
    width: 60.379,
    height: 99.944,
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17940",
    "data-name": "Grupo 17940",
    transform: "translate(2.571 2.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17939",
    "data-name": "Grupo 17939"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4589",
    "data-name": "Rect\\xE1ngulo 4589",
    width: 55.237,
    height: 95.891,
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17945",
    "data-name": "Grupo 17945",
    transform: "translate(13.086 14.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17942",
    "data-name": "Grupo 17942",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17941",
    "data-name": "Grupo 17941"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4590",
    "data-name": "Rect\\xE1ngulo 4590",
    width: 33.966,
    height: 70.97,
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17944",
    "data-name": "Grupo 17944",
    transform: "translate(0 19.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17943",
    "data-name": "Grupo 17943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12977",
    "data-name": "Trazado 12977",
    d: "M56.652,132.686c-.079-6.629,5.882-13.1,12.447-14.027,3.13-.441,6.457.18,9.382-1.02,5.221-2.141,6.882-9.078,12.137-11.135l.24,51.3H56.652Z",
    transform: "translate(-56.651 -106.504)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18068",
    "data-name": "Grupo 18068",
    transform: "translate(130.444 18.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17952",
    "data-name": "Grupo 17952",
    transform: "translate(59.636 9.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17951",
    "data-name": "Grupo 17951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17950",
    "data-name": "Grupo 17950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17949",
    "data-name": "Grupo 17949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17948",
    "data-name": "Grupo 17948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17947",
    "data-name": "Grupo 17947"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4591",
    "data-name": "Rect\\xE1ngulo 4591",
    width: 4.956,
    height: 24.659,
    transform: "matrix(1, -0.005, 0.005, 1, 0, 0.027)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17972",
    "data-name": "Grupo 17972",
    transform: "translate(16.611 9.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17958",
    "data-name": "Grupo 17958",
    transform: "translate(0.093 0.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17957",
    "data-name": "Grupo 17957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17956",
    "data-name": "Grupo 17956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17955",
    "data-name": "Grupo 17955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17954",
    "data-name": "Grupo 17954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17953",
    "data-name": "Grupo 17953"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4592",
    "data-name": "Rect\\xE1ngulo 4592",
    width: 12.833,
    height: 13.613,
    transform: "translate(0 0.069) rotate(-0.306)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17964",
    "data-name": "Grupo 17964",
    transform: "translate(12.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17963",
    "data-name": "Grupo 17963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17962",
    "data-name": "Grupo 17962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17961",
    "data-name": "Grupo 17961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17960",
    "data-name": "Grupo 17960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17959",
    "data-name": "Grupo 17959"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4593",
    "data-name": "Rect\\xE1ngulo 4593",
    width: 12.833,
    height: 13.613,
    transform: "matrix(1, -0.005, 0.005, 1, 0, 0.069)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17971",
    "data-name": "Grupo 17971",
    transform: "translate(0 3.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17970",
    "data-name": "Grupo 17970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17969",
    "data-name": "Grupo 17969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17968",
    "data-name": "Grupo 17968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17967",
    "data-name": "Grupo 17967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17966",
    "data-name": "Grupo 17966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17965",
    "data-name": "Grupo 17965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12978",
    "data-name": "Trazado 12978",
    d: "M327.313,101.149c8.528.07,17.078.021,25.605-.118a.136.136,0,0,0,0-.272c-8.528-.048-17.078-.005-25.605.156a.117.117,0,0,0,0,.234Z",
    transform: "translate(-327.2 -100.741)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17992",
    "data-name": "Grupo 17992",
    transform: "translate(8.606 22.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17978",
    "data-name": "Grupo 17978",
    transform: "translate(0.097 0.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17977",
    "data-name": "Grupo 17977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17976",
    "data-name": "Grupo 17976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17975",
    "data-name": "Grupo 17975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17974",
    "data-name": "Grupo 17974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17973",
    "data-name": "Grupo 17973"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4594",
    "data-name": "Rect\\xE1ngulo 4594",
    width: 23.316,
    height: 11.094,
    transform: "translate(0 0.125) rotate(-0.307)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17984",
    "data-name": "Grupo 17984",
    transform: "translate(23.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17983",
    "data-name": "Grupo 17983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17982",
    "data-name": "Grupo 17982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17981",
    "data-name": "Grupo 17981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17980",
    "data-name": "Grupo 17980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17979",
    "data-name": "Grupo 17979"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4595",
    "data-name": "Rect\\xE1ngulo 4595",
    width: 23.316,
    height: 11.094,
    transform: "translate(0 0.125) rotate(-0.307)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17991",
    "data-name": "Grupo 17991",
    transform: "translate(0 2.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17990",
    "data-name": "Grupo 17990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17989",
    "data-name": "Grupo 17989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17988",
    "data-name": "Grupo 17988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17987",
    "data-name": "Grupo 17987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17986",
    "data-name": "Grupo 17986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17985",
    "data-name": "Grupo 17985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12979",
    "data-name": "Trazado 12979",
    d: "M311.147,126.8c15.49.175,31.032.018,46.521-.23a.136.136,0,0,0,0-.272c-15.49-.082-31.034-.073-46.52.268a.117.117,0,0,0,0,.234Z",
    transform: "translate(-311.034 -126.25)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18008",
    "data-name": "Grupo 18008",
    transform: "translate(0 33.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17997",
    "data-name": "Grupo 17997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17996",
    "data-name": "Grupo 17996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17995",
    "data-name": "Grupo 17995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17994",
    "data-name": "Grupo 17994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17993",
    "data-name": "Grupo 17993"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4596",
    "data-name": "Rect\\xE1ngulo 4596",
    width: 90.332,
    height: 3.974,
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18002",
    "data-name": "Grupo 18002",
    transform: "translate(14.789 1.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18001",
    "data-name": "Grupo 18001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18000",
    "data-name": "Grupo 18000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17999",
    "data-name": "Grupo 17999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17998",
    "data-name": "Grupo 17998"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4597",
    "data-name": "Rect\\xE1ngulo 4597",
    width: 3.667,
    height: 13.562,
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18007",
    "data-name": "Grupo 18007",
    transform: "translate(69.53 1.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18006",
    "data-name": "Grupo 18006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18005",
    "data-name": "Grupo 18005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18004",
    "data-name": "Grupo 18004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18003",
    "data-name": "Grupo 18003"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4598",
    "data-name": "Rect\\xE1ngulo 4598",
    width: 3.667,
    height: 13.562,
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18014",
    "data-name": "Grupo 18014",
    transform: "translate(64.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18013",
    "data-name": "Grupo 18013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18012",
    "data-name": "Grupo 18012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18011",
    "data-name": "Grupo 18011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18010",
    "data-name": "Grupo 18010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18009",
    "data-name": "Grupo 18009"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4599",
    "data-name": "Rect\\xE1ngulo 4599",
    width: 4.956,
    height: 33.915,
    transform: "matrix(1, -0.005, 0.005, 1, 0, 0.027)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18051",
    "data-name": "Grupo 18051",
    transform: "translate(69.418 6.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18020",
    "data-name": "Grupo 18020",
    transform: "translate(0.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18019",
    "data-name": "Grupo 18019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18018",
    "data-name": "Grupo 18018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18017",
    "data-name": "Grupo 18017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18016",
    "data-name": "Grupo 18016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18015",
    "data-name": "Grupo 18015"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4600",
    "data-name": "Rect\\xE1ngulo 4600",
    width: 7.7,
    height: 27.484,
    transform: "matrix(1, -0.005, 0.005, 1, 0, 0.041)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18026",
    "data-name": "Grupo 18026",
    transform: "translate(0 5.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18025",
    "data-name": "Grupo 18025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18024",
    "data-name": "Grupo 18024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18023",
    "data-name": "Grupo 18023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18022",
    "data-name": "Grupo 18022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18021",
    "data-name": "Grupo 18021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12980",
    "data-name": "Trazado 12980",
    d: "M441.544,98.442a55.712,55.712,0,0,1-7.7,0,55.506,55.506,0,0,1,7.7,0Z",
    transform: "translate(-433.844 -98.308)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18032",
    "data-name": "Grupo 18032",
    transform: "translate(0 4.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18031",
    "data-name": "Grupo 18031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18030",
    "data-name": "Grupo 18030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18029",
    "data-name": "Grupo 18029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18028",
    "data-name": "Grupo 18028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18027",
    "data-name": "Grupo 18027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12981",
    "data-name": "Trazado 12981",
    d: "M441.544,96.11a55.709,55.709,0,0,1-7.7,0,55.712,55.712,0,0,1,7.7,0Z",
    transform: "translate(-433.844 -95.977)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18038",
    "data-name": "Grupo 18038",
    transform: "translate(0 23.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18037",
    "data-name": "Grupo 18037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18036",
    "data-name": "Grupo 18036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18035",
    "data-name": "Grupo 18035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18034",
    "data-name": "Grupo 18034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18033",
    "data-name": "Grupo 18033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12982",
    "data-name": "Trazado 12982",
    d: "M441.544,134.9a55.709,55.709,0,0,1-7.7,0,55.506,55.506,0,0,1,7.7,0Z",
    transform: "translate(-433.844 -134.767)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18044",
    "data-name": "Grupo 18044",
    transform: "translate(0 22.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18043",
    "data-name": "Grupo 18043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18042",
    "data-name": "Grupo 18042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18041",
    "data-name": "Grupo 18041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18040",
    "data-name": "Grupo 18040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18039",
    "data-name": "Grupo 18039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12983",
    "data-name": "Trazado 12983",
    d: "M441.544,132.569a55.5,55.5,0,0,1-7.7,0,55.715,55.715,0,0,1,7.7,0Z",
    transform: "translate(-433.844 -132.436)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18050",
    "data-name": "Grupo 18050",
    transform: "translate(3.841 7.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18049",
    "data-name": "Grupo 18049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18048",
    "data-name": "Grupo 18048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18047",
    "data-name": "Grupo 18047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18046",
    "data-name": "Grupo 18046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18045",
    "data-name": "Grupo 18045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12984",
    "data-name": "Trazado 12984",
    d: "M441.734,114.991c-.074,0-.133-2.773-.133-6.193s.059-6.193.133-6.193.134,2.772.134,6.193S441.808,114.991,441.734,114.991Z",
    transform: "translate(-441.601 -102.605)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18057",
    "data-name": "Grupo 18057",
    transform: "translate(77.202 13.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18056",
    "data-name": "Grupo 18056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18055",
    "data-name": "Grupo 18055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18054",
    "data-name": "Grupo 18054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18053",
    "data-name": "Grupo 18053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18052",
    "data-name": "Grupo 18052"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4601",
    "data-name": "Rect\\xE1ngulo 4601",
    width: 8.382,
    height: 20.745,
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18062",
    "data-name": "Grupo 18062",
    transform: "translate(65.452 4.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18061",
    "data-name": "Grupo 18061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18060",
    "data-name": "Grupo 18060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18059",
    "data-name": "Grupo 18059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18058",
    "data-name": "Grupo 18058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12985",
    "data-name": "Trazado 12985",
    d: "M428.684,85.377a1.424,1.424,0,1,1-1.425-1.425A1.424,1.424,0,0,1,428.684,85.377Z",
    transform: "translate(-425.835 -83.952)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18067",
    "data-name": "Grupo 18067",
    transform: "translate(66.436 9.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18066",
    "data-name": "Grupo 18066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18065",
    "data-name": "Grupo 18065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18064",
    "data-name": "Grupo 18064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18063",
    "data-name": "Grupo 18063"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4602",
    "data-name": "Rect\\xE1ngulo 4602",
    width: 0.88,
    height: 20.175,
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18377",
    "data-name": "Grupo 18377",
    transform: "translate(61.957 185.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18110",
    "data-name": "Grupo 18110",
    transform: "translate(7.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18073",
    "data-name": "Grupo 18073",
    transform: "translate(0 0.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18072",
    "data-name": "Grupo 18072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18071",
    "data-name": "Grupo 18071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18070",
    "data-name": "Grupo 18070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18069",
    "data-name": "Grupo 18069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12986",
    "data-name": "Trazado 12986",
    d: "M171.672,412.334s-4.54,3.459-.191,8.029a.4.4,0,0,0,.288.122l39.665-.232a6.913,6.913,0,0,0,.577-8.177Z",
    transform: "translate(-169.596 -412.076)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18079",
    "data-name": "Grupo 18079",
    transform: "translate(11.009 3.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18078",
    "data-name": "Grupo 18078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18077",
    "data-name": "Grupo 18077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18076",
    "data-name": "Grupo 18076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18075",
    "data-name": "Grupo 18075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18074",
    "data-name": "Grupo 18074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12987",
    "data-name": "Trazado 12987",
    d: "M213.892,419.806c0,.044-4.939.08-11.031.08s-11.032-.036-11.032-.08,4.938-.08,11.032-.08S213.892,419.762,213.892,419.806Z",
    transform: "translate(-191.829 -419.726)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18085",
    "data-name": "Grupo 18085",
    transform: "translate(16.529 5.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18084",
    "data-name": "Grupo 18084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18083",
    "data-name": "Grupo 18083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18082",
    "data-name": "Grupo 18082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18081",
    "data-name": "Grupo 18081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18080",
    "data-name": "Grupo 18080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12988",
    "data-name": "Trazado 12988",
    d: "M213.35,422.7c0,.044-2.322.08-5.186.08s-5.187-.036-5.187-.08,2.322-.08,5.187-.08S213.35,422.66,213.35,422.7Z",
    transform: "translate(-202.977 -422.624)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18091",
    "data-name": "Grupo 18091",
    transform: "translate(37.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18090",
    "data-name": "Grupo 18090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18089",
    "data-name": "Grupo 18089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18088",
    "data-name": "Grupo 18088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18087",
    "data-name": "Grupo 18087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18086",
    "data-name": "Grupo 18086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12989",
    "data-name": "Trazado 12989",
    d: "M244.493,420.014c-.026-.007.087-.456.21-1.19a16.43,16.43,0,0,0-.054-5.784c-.137-.732-.258-1.178-.233-1.185a1.257,1.257,0,0,1,.115.305c.066.2.145.492.228.858a14.055,14.055,0,0,1,.055,5.827c-.076.367-.15.662-.212.862A1.292,1.292,0,0,1,244.493,420.014Z",
    transform: "translate(-244.412 -411.855)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18097",
    "data-name": "Grupo 18097",
    transform: "translate(40.085 0.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18096",
    "data-name": "Grupo 18096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18095",
    "data-name": "Grupo 18095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18094",
    "data-name": "Grupo 18094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18093",
    "data-name": "Grupo 18093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18092",
    "data-name": "Grupo 18092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12990",
    "data-name": "Trazado 12990",
    d: "M250.551,411.976a1.344,1.344,0,0,1,.177.288,3.387,3.387,0,0,1,.176.355c.062.142.14.3.2.485a8.44,8.44,0,0,1,.377,1.316,8.844,8.844,0,0,1,.027,3.341,8.478,8.478,0,0,1-.357,1.323c-.059.186-.135.346-.195.488a3.411,3.411,0,0,1-.17.358,1.353,1.353,0,0,1-.172.291c-.027-.013.194-.441.43-1.174a9.517,9.517,0,0,0,.318-1.311,9.447,9.447,0,0,0-.027-3.287,9.481,9.481,0,0,0-.339-1.306C250.752,412.414,250.523,411.99,250.551,411.976Z",
    transform: "translate(-250.549 -411.976)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18103",
    "data-name": "Grupo 18103",
    transform: "translate(7.211 0.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18102",
    "data-name": "Grupo 18102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18101",
    "data-name": "Grupo 18101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18100",
    "data-name": "Grupo 18100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18099",
    "data-name": "Grupo 18099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18098",
    "data-name": "Grupo 18098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12991",
    "data-name": "Trazado 12991",
    d: "M185.282,420.516a1.262,1.262,0,0,1-.185-.265,2.9,2.9,0,0,1-.185-.331,4.687,4.687,0,0,1-.212-.456,6.949,6.949,0,0,1-.387-1.251,7.361,7.361,0,0,1,.043-3.191,6.911,6.911,0,0,1,.42-1.24,4.72,4.72,0,0,1,.224-.451,2.83,2.83,0,0,1,.194-.325,1.272,1.272,0,0,1,.192-.26c.027.017-.228.4-.506,1.08a7.739,7.739,0,0,0-.381,1.229,7.761,7.761,0,0,0-.042,3.13,7.748,7.748,0,0,0,.347,1.238C185.065,420.11,185.31,420.5,185.282,420.516Z",
    transform: "translate(-184.16 -412.744)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18109",
    "data-name": "Grupo 18109",
    transform: "translate(2.721 0.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18108",
    "data-name": "Grupo 18108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18107",
    "data-name": "Grupo 18107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18106",
    "data-name": "Grupo 18106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18105",
    "data-name": "Grupo 18105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18104",
    "data-name": "Grupo 18104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12992",
    "data-name": "Trazado 12992",
    d: "M176.422,421.418a1.557,1.557,0,0,1-.2-.3,3.49,3.49,0,0,1-.207-.373c-.073-.149-.165-.315-.24-.512a8.4,8.4,0,0,1-.454-1.4,8.863,8.863,0,0,1-.08-3.588,8.44,8.44,0,0,1,.392-1.419c.066-.2.151-.369.217-.522a3.531,3.531,0,0,1,.191-.381,1.572,1.572,0,0,1,.19-.309c.029.015-.225.466-.491,1.25a9.305,9.305,0,0,0-.353,1.406,9.341,9.341,0,0,0,.078,3.531,9.341,9.341,0,0,0,.415,1.389C176.177,420.962,176.45,421.4,176.422,421.418Z",
    transform: "translate(-175.092 -412.614)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18187",
    "data-name": "Grupo 18187",
    transform: "translate(0 19.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18151",
    "data-name": "Grupo 18151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18115",
    "data-name": "Grupo 18115",
    transform: "translate(32.752 0.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18114",
    "data-name": "Grupo 18114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18113",
    "data-name": "Grupo 18113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18112",
    "data-name": "Grupo 18112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18111",
    "data-name": "Grupo 18111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12993",
    "data-name": "Trazado 12993",
    d: "M236.176,452.985v7.591H221.488v-7.591Z",
    transform: "translate(-221.488 -452.985)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18120",
    "data-name": "Grupo 18120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18119",
    "data-name": "Grupo 18119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18118",
    "data-name": "Grupo 18118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18117",
    "data-name": "Grupo 18117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18116",
    "data-name": "Grupo 18116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12994",
    "data-name": "Trazado 12994",
    d: "M155.349,456.029c0,.067.005.134.009.2a4.35,4.35,0,0,0,4.369,4.073H203.47v-.549H193.086a3.8,3.8,0,0,1-3.8-3.8h0a3.8,3.8,0,0,1,3.8-3.8H203.47v-.806l-43.756.148A4.376,4.376,0,0,0,155.349,456.029Z",
    transform: "translate(-155.346 -451.357)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18126",
    "data-name": "Grupo 18126",
    transform: "translate(33.95 4.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18125",
    "data-name": "Grupo 18125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18124",
    "data-name": "Grupo 18124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18123",
    "data-name": "Grupo 18123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18122",
    "data-name": "Grupo 18122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18121",
    "data-name": "Grupo 18121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12995",
    "data-name": "Trazado 12995",
    d: "M237.4,460.773c0,.044-3.02.08-6.744.08s-6.745-.036-6.745-.08,3.019-.08,6.745-.08S237.4,460.729,237.4,460.773Z",
    transform: "translate(-223.908 -460.693)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18132",
    "data-name": "Grupo 18132",
    transform: "translate(34.463 6.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18131",
    "data-name": "Grupo 18131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18130",
    "data-name": "Grupo 18130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18129",
    "data-name": "Grupo 18129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18128",
    "data-name": "Grupo 18128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18127",
    "data-name": "Grupo 18127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12996",
    "data-name": "Trazado 12996",
    d: "M237.708,464.227c0,.044-2.858.08-6.382.08s-6.383-.036-6.383-.08,2.857-.08,6.383-.08S237.708,464.183,237.708,464.227Z",
    transform: "translate(-224.943 -464.147)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18138",
    "data-name": "Grupo 18138",
    transform: "translate(35.963 7.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18137",
    "data-name": "Grupo 18137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18136",
    "data-name": "Grupo 18136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18135",
    "data-name": "Grupo 18135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18134",
    "data-name": "Grupo 18134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18133",
    "data-name": "Grupo 18133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12997",
    "data-name": "Trazado 12997",
    d: "M239.45,467.386c0,.045-2.569.08-5.738.08s-5.739-.036-5.739-.08,2.568-.08,5.739-.08S239.45,467.342,239.45,467.386Z",
    transform: "translate(-227.974 -467.306)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18144",
    "data-name": "Grupo 18144",
    transform: "translate(34.226 3.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18143",
    "data-name": "Grupo 18143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18142",
    "data-name": "Grupo 18142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18141",
    "data-name": "Grupo 18141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18140",
    "data-name": "Grupo 18140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18139",
    "data-name": "Grupo 18139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12998",
    "data-name": "Trazado 12998",
    d: "M237.679,457.669c0,.044-2.958.08-6.607.08s-6.607-.036-6.607-.08,2.957-.08,6.607-.08S237.679,457.625,237.679,457.669Z",
    transform: "translate(-224.466 -457.589)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18150",
    "data-name": "Grupo 18150",
    transform: "translate(35.466 1.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18149",
    "data-name": "Grupo 18149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18148",
    "data-name": "Grupo 18148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18147",
    "data-name": "Grupo 18147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18146",
    "data-name": "Grupo 18146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18145",
    "data-name": "Grupo 18145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12999",
    "data-name": "Trazado 12999",
    d: "M238.73,454.566c0,.045-2.633.08-5.881.08s-5.881-.036-5.881-.08,2.632-.08,5.881-.08S238.73,454.522,238.73,454.566Z",
    transform: "translate(-226.969 -454.486)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18157",
    "data-name": "Grupo 18157",
    transform: "translate(3.215 0.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18156",
    "data-name": "Grupo 18156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18155",
    "data-name": "Grupo 18155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18154",
    "data-name": "Grupo 18154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18153",
    "data-name": "Grupo 18153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18152",
    "data-name": "Grupo 18152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13000",
    "data-name": "Trazado 13000",
    d: "M163.927,451.912a9.776,9.776,0,0,0-.929,1.105,5.62,5.62,0,0,0,.077,6.5,9.729,9.729,0,0,0,.955,1.083,1.557,1.557,0,0,1-.316-.233,5.012,5.012,0,0,1-.731-.783,5.538,5.538,0,0,1-.078-6.636,5.017,5.017,0,0,1,.712-.8A1.542,1.542,0,0,1,163.927,451.912Z",
    transform: "translate(-161.839 -451.911)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18163",
    "data-name": "Grupo 18163",
    transform: "translate(1.736 0.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18162",
    "data-name": "Grupo 18162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18161",
    "data-name": "Grupo 18161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18160",
    "data-name": "Grupo 18160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18159",
    "data-name": "Grupo 18159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18158",
    "data-name": "Grupo 18158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13001",
    "data-name": "Trazado 13001",
    d: "M160.939,451.585a9.776,9.776,0,0,0-.929,1.105,5.62,5.62,0,0,0,.077,6.5,9.731,9.731,0,0,0,.955,1.083,1.539,1.539,0,0,1-.316-.233,5.007,5.007,0,0,1-.731-.783,5.536,5.536,0,0,1-.078-6.636,4.994,4.994,0,0,1,.712-.8A1.543,1.543,0,0,1,160.939,451.585Z",
    transform: "translate(-158.851 -451.584)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18169",
    "data-name": "Grupo 18169",
    transform: "translate(31.458 0.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18168",
    "data-name": "Grupo 18168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18167",
    "data-name": "Grupo 18167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18166",
    "data-name": "Grupo 18166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18165",
    "data-name": "Grupo 18165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18164",
    "data-name": "Grupo 18164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13002",
    "data-name": "Trazado 13002",
    d: "M220.964,451.912a9.743,9.743,0,0,0-.929,1.105,5.621,5.621,0,0,0,.077,6.5,9.728,9.728,0,0,0,.955,1.083,1.556,1.556,0,0,1-.316-.233,5.014,5.014,0,0,1-.73-.783,5.537,5.537,0,0,1-.079-6.636,5.042,5.042,0,0,1,.712-.8A1.518,1.518,0,0,1,220.964,451.912Z",
    transform: "translate(-218.876 -451.911)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18175",
    "data-name": "Grupo 18175",
    transform: "translate(29.979 0.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18174",
    "data-name": "Grupo 18174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18173",
    "data-name": "Grupo 18173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18172",
    "data-name": "Grupo 18172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18171",
    "data-name": "Grupo 18171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18170",
    "data-name": "Grupo 18170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13003",
    "data-name": "Trazado 13003",
    d: "M217.977,451.585a9.743,9.743,0,0,0-.929,1.105,5.621,5.621,0,0,0,.077,6.5,9.79,9.79,0,0,0,.955,1.083,1.554,1.554,0,0,1-.316-.233,5.01,5.01,0,0,1-.73-.783,5.537,5.537,0,0,1-.079-6.636,5.018,5.018,0,0,1,.712-.8A1.519,1.519,0,0,1,217.977,451.585Z",
    transform: "translate(-215.889 -451.584)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18180",
    "data-name": "Grupo 18180",
    transform: "translate(7.982 1.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18179",
    "data-name": "Grupo 18179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18178",
    "data-name": "Grupo 18178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18177",
    "data-name": "Grupo 18177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18176",
    "data-name": "Grupo 18176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13004",
    "data-name": "Trazado 13004",
    d: "M173.765,458.438q-.021-1.543-.042-3.086a2.2,2.2,0,0,0-.109-.8.748.748,0,0,0-.586-.494,1.173,1.173,0,0,0-1.259.6,2.927,2.927,0,0,0-.3,1.513,21.9,21.9,0,0,0,.118,2.438,2.809,2.809,0,0,0,.287,1.117,1.042,1.042,0,0,0,.942.566,1.053,1.053,0,0,0,.824-.716A3.1,3.1,0,0,0,173.765,458.438Z",
    transform: "translate(-171.466 -454.016)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18186",
    "data-name": "Grupo 18186",
    transform: "translate(13.144 4.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18185",
    "data-name": "Grupo 18185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18184",
    "data-name": "Grupo 18184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18183",
    "data-name": "Grupo 18183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18182",
    "data-name": "Grupo 18182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18181",
    "data-name": "Grupo 18181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13005",
    "data-name": "Trazado 13005",
    d: "M196.016,461.072c0,.045-3.162.08-7.062.08s-7.063-.036-7.063-.08,3.162-.08,7.063-.08S196.016,461.028,196.016,461.072Z",
    transform: "translate(-181.891 -460.992)",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18341",
    "data-name": "Grupo 18341",
    transform: "translate(7.062 12.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18278",
    "data-name": "Grupo 18278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18223",
    "data-name": "Grupo 18223",
    transform: "translate(0.208 0.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18192",
    "data-name": "Grupo 18192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18191",
    "data-name": "Grupo 18191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18190",
    "data-name": "Grupo 18190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18189",
    "data-name": "Grupo 18189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18188",
    "data-name": "Grupo 18188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13006",
    "data-name": "Trazado 13006",
    d: "M170.109,443.964l-.081-7.195h3.917l.135,7.195Z",
    transform: "translate(-170.028 -436.769)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18198",
    "data-name": "Grupo 18198",
    transform: "translate(0.045 1.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18197",
    "data-name": "Grupo 18197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18196",
    "data-name": "Grupo 18196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18195",
    "data-name": "Grupo 18195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18194",
    "data-name": "Grupo 18194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18193",
    "data-name": "Grupo 18193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13007",
    "data-name": "Trazado 13007",
    d: "M173.759,439.273a20.683,20.683,0,0,1-3.64,0,20.817,20.817,0,0,1,3.64,0Z",
    transform: "translate(-170.119 -439.193)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18204",
    "data-name": "Grupo 18204",
    transform: "translate(0.045 2.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18203",
    "data-name": "Grupo 18203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18202",
    "data-name": "Grupo 18202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18201",
    "data-name": "Grupo 18201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18200",
    "data-name": "Grupo 18200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18199",
    "data-name": "Grupo 18199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13008",
    "data-name": "Trazado 13008",
    d: "M173.759,441.515a20.675,20.675,0,0,1-3.64,0,20.691,20.691,0,0,1,3.64,0Z",
    transform: "translate(-170.119 -441.435)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18210",
    "data-name": "Grupo 18210",
    transform: "translate(0.045 3.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18209",
    "data-name": "Grupo 18209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18208",
    "data-name": "Grupo 18208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18207",
    "data-name": "Grupo 18207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18206",
    "data-name": "Grupo 18206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18205",
    "data-name": "Grupo 18205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13009",
    "data-name": "Trazado 13009",
    d: "M173.759,443.758a20.817,20.817,0,0,1-3.64,0,20.683,20.683,0,0,1,3.64,0Z",
    transform: "translate(-170.119 -443.678)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18216",
    "data-name": "Grupo 18216",
    transform: "translate(0.045 4.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18215",
    "data-name": "Grupo 18215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18214",
    "data-name": "Grupo 18214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18213",
    "data-name": "Grupo 18213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18212",
    "data-name": "Grupo 18212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18211",
    "data-name": "Grupo 18211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13010",
    "data-name": "Trazado 13010",
    d: "M173.759,446a20.683,20.683,0,0,1-3.64,0,20.691,20.691,0,0,1,3.64,0Z",
    transform: "translate(-170.119 -445.92)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18222",
    "data-name": "Grupo 18222",
    transform: "translate(0.045 5.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18221",
    "data-name": "Grupo 18221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18220",
    "data-name": "Grupo 18220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18219",
    "data-name": "Grupo 18219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18218",
    "data-name": "Grupo 18218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18217",
    "data-name": "Grupo 18217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13011",
    "data-name": "Trazado 13011",
    d: "M173.759,448.243a20.691,20.691,0,0,1-3.64,0,20.683,20.683,0,0,1,3.64,0Z",
    transform: "translate(-170.119 -448.163)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18228",
    "data-name": "Grupo 18228",
    transform: "translate(0 0.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18227",
    "data-name": "Grupo 18227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18226",
    "data-name": "Grupo 18226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18225",
    "data-name": "Grupo 18225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18224",
    "data-name": "Grupo 18224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13012",
    "data-name": "Trazado 13012",
    d: "M169.608,436.384h43.407a20.4,20.4,0,0,1,0,7.777H169.793v-.529h2.641a1.247,1.247,0,0,0,1.247-1.247v-4.3a1.247,1.247,0,0,0-1.247-1.247h-2.826Z",
    transform: "translate(-169.608 -436.384)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18253",
    "data-name": "Grupo 18253",
    transform: "translate(9.22 2.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18232",
    "data-name": "Grupo 18232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18231",
    "data-name": "Grupo 18231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18230",
    "data-name": "Grupo 18230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18229",
    "data-name": "Grupo 18229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13013",
    "data-name": "Trazado 13013",
    d: "M189.27,442.7h.724a.165.165,0,0,1,.078.02.147.147,0,0,1,.078.136.16.16,0,0,1-.005.047c-.014.061-.031.123-.049.185a2.062,2.062,0,0,1-.454.82.856.856,0,0,1-.617.319.658.658,0,0,1-.087-.005.705.705,0,0,1-.493-.357,1.627,1.627,0,0,1-.216-.872,2.355,2.355,0,0,1,.086-.621,2.081,2.081,0,0,1,.43-.839.875.875,0,0,1,.653-.347.619.619,0,0,1,.274.062.889.889,0,0,1,.422.529.157.157,0,0,1,.018.072.154.154,0,0,1-.021.078.149.149,0,0,1-.135.077.173.173,0,0,1-.049-.007.149.149,0,0,1-.1-.1l-.008-.014a.763.763,0,0,0-.087-.171.414.414,0,0,0-.347-.207.407.407,0,0,0-.24.088,1.281,1.281,0,0,0-.4.568,2.136,2.136,0,0,0-.171.818,1.472,1.472,0,0,0,.124.642.422.422,0,0,0,.378.284.518.518,0,0,0,.35-.211,1.935,1.935,0,0,0,.372-.672c-.333,0-.507,0-.52-.006q-.169-.027-.173-.175a.155.155,0,0,1,.016-.052A.164.164,0,0,1,189.27,442.7Z",
    transform: "translate(-188.228 -441.187)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18236",
    "data-name": "Grupo 18236",
    transform: "translate(1.951 0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18235",
    "data-name": "Grupo 18235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18234",
    "data-name": "Grupo 18234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18233",
    "data-name": "Grupo 18233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13014",
    "data-name": "Trazado 13014",
    d: "M193.723,441.312a.479.479,0,0,1,.019.053q.046.159.511,2.69a.107.107,0,0,1,.007.039.162.162,0,0,1-.021.08.143.143,0,0,1-.13.079h-.025a.141.141,0,0,1-.12-.107l-.173-.894H192.9l-.429.9a.164.164,0,0,1-.014.03.172.172,0,0,1-.134.076.158.158,0,0,1-.085-.025.151.151,0,0,1-.071-.131.121.121,0,0,1,.01-.047c.027-.063.071-.161.133-.3q.937-2.043,1.12-2.412a.169.169,0,0,1,.151-.109A.165.165,0,0,1,193.723,441.312Zm-.195.6-.482,1.015h.681Z",
    transform: "translate(-192.168 -441.234)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18240",
    "data-name": "Grupo 18240",
    transform: "translate(4.462 0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18239",
    "data-name": "Grupo 18239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18238",
    "data-name": "Grupo 18238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18237",
    "data-name": "Grupo 18237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13015",
    "data-name": "Trazado 13015",
    d: "M198.7,444.248H197.4a.153.153,0,0,1-.084-.025.237.237,0,0,1-.074-.164v0q0-.079.361-2.678a.422.422,0,0,1,.008-.057.143.143,0,0,1,.14-.1.149.149,0,0,1,.072.018.145.145,0,0,1,.082.138q-.017.178-.089.734-.224,1.715-.234,1.81h1.112a.221.221,0,0,1,.084.016.146.146,0,0,1,.1.146.178.178,0,0,1-.007.051A.183.183,0,0,1,198.7,444.248Z",
    transform: "translate(-197.238 -441.226)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18244",
    "data-name": "Grupo 18244",
    transform: "translate(6.161 0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18243",
    "data-name": "Grupo 18243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18242",
    "data-name": "Grupo 18242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18241",
    "data-name": "Grupo 18241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13016",
    "data-name": "Trazado 13016",
    d: "M202.225,441.312a.476.476,0,0,1,.019.053q.046.159.511,2.69a.107.107,0,0,1,.007.039.162.162,0,0,1-.021.08.144.144,0,0,1-.13.079h-.025a.141.141,0,0,1-.12-.107l-.173-.894H201.4l-.428.9a.2.2,0,0,1-.014.03.172.172,0,0,1-.134.076.158.158,0,0,1-.085-.025.151.151,0,0,1-.071-.131.121.121,0,0,1,.01-.047c.027-.063.071-.161.133-.3q.936-2.043,1.12-2.412a.169.169,0,0,1,.151-.109A.165.165,0,0,1,202.225,441.312Zm-.195.6-.482,1.015h.681Z",
    transform: "translate(-200.67 -441.234)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18248",
    "data-name": "Grupo 18248",
    transform: "translate(8.546 0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18247",
    "data-name": "Grupo 18247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18246",
    "data-name": "Grupo 18246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18245",
    "data-name": "Grupo 18245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13017",
    "data-name": "Trazado 13017",
    d: "M206.741,442.856l.237.656q.2.559.2.59a.138.138,0,0,1-.025.079.147.147,0,0,1-.131.071.143.143,0,0,1-.13-.1l-.024-.066q-.107-.244-.35-.922l-.74,1.012a.179.179,0,0,1-.139.082.164.164,0,0,1-.081-.021.144.144,0,0,1-.074-.13.214.214,0,0,1,0-.033.384.384,0,0,1,.078-.127q.373-.481.822-1.145l-.09-.247q-.417-1.119-.417-1.156a.173.173,0,0,1,.02-.08.136.136,0,0,1,.126-.078.157.157,0,0,1,.146.087l.436,1.177.873-1.188a.176.176,0,0,1,.139-.074.146.146,0,0,1,.147.157.2.2,0,0,1-.016.072Z",
    transform: "translate(-205.487 -441.234)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18252",
    "data-name": "Grupo 18252",
    transform: "translate(10.793 0.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18251",
    "data-name": "Grupo 18251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18250",
    "data-name": "Grupo 18250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18249",
    "data-name": "Grupo 18249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13018",
    "data-name": "Trazado 13018",
    d: "M212.27,441.254a.157.157,0,0,1,.072.018.154.154,0,0,1,.084.134q-.321,2.537-.354,2.742a1.677,1.677,0,0,1-.28.714,1.009,1.009,0,0,1-1.287.315.929.929,0,0,1-.462-.4.167.167,0,0,1-.017-.076.152.152,0,0,1,.021-.078.149.149,0,0,1,.253-.013.84.84,0,0,0,.67.381.662.662,0,0,0,.52-.264,1.441,1.441,0,0,0,.288-.822.785.785,0,0,1-.662.358.662.662,0,0,1-.088-.006.7.7,0,0,1-.5-.357,1.618,1.618,0,0,1-.218-.872c0-.159.007-.322.021-.491q.037-.4.177-1.127a.158.158,0,0,1,.014-.045.143.143,0,0,1,.14-.107.15.15,0,0,1,.076.021.138.138,0,0,1,.078.125,5.811,5.811,0,0,1-.072.6,8.215,8.215,0,0,0-.1.912,1.831,1.831,0,0,0,.117.71q.134.319.388.319a.247.247,0,0,0,.052-.006.711.711,0,0,0,.391-.313,1.947,1.947,0,0,0,.323-.721l.2-1.491a.188.188,0,0,1,.02-.066A.142.142,0,0,1,212.27,441.254Z",
    transform: "translate(-210.025 -441.254)",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18259",
    "data-name": "Grupo 18259",
    transform: "translate(41.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18258",
    "data-name": "Grupo 18258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18257",
    "data-name": "Grupo 18257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18256",
    "data-name": "Grupo 18256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18255",
    "data-name": "Grupo 18255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18254",
    "data-name": "Grupo 18254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13019",
    "data-name": "Trazado 13019",
    d: "M253.9,444.159c-.045,0-.08-1.787-.08-3.99s.036-3.99.08-3.99.08,1.786.08,3.99S253.939,444.159,253.9,444.159Z",
    transform: "translate(-253.815 -436.18)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18265",
    "data-name": "Grupo 18265",
    transform: "translate(6.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18264",
    "data-name": "Grupo 18264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18263",
    "data-name": "Grupo 18263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18262",
    "data-name": "Grupo 18262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18261",
    "data-name": "Grupo 18261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18260",
    "data-name": "Grupo 18260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13020",
    "data-name": "Trazado 13020",
    d: "M182.161,444.159c-.044,0-.08-1.787-.08-3.99s.036-3.99.08-3.99.08,1.786.08,3.99S182.205,444.159,182.161,444.159Z",
    transform: "translate(-182.081 -436.18)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18271",
    "data-name": "Grupo 18271",
    transform: "translate(42.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18270",
    "data-name": "Grupo 18270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18269",
    "data-name": "Grupo 18269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18268",
    "data-name": "Grupo 18268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18267",
    "data-name": "Grupo 18267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18266",
    "data-name": "Grupo 18266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13021",
    "data-name": "Trazado 13021",
    d: "M255.433,444.159c-.045,0-.08-1.787-.08-3.99s.036-3.99.08-3.99.08,1.786.08,3.99S255.477,444.159,255.433,444.159Z",
    transform: "translate(-255.353 -436.18)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18277",
    "data-name": "Grupo 18277",
    transform: "translate(5.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18276",
    "data-name": "Grupo 18276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18275",
    "data-name": "Grupo 18275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18274",
    "data-name": "Grupo 18274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18273",
    "data-name": "Grupo 18273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18272",
    "data-name": "Grupo 18272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13022",
    "data-name": "Trazado 13022",
    d: "M180.724,444.159c-.044,0-.08-1.787-.08-3.99s.036-3.99.08-3.99.08,1.786.08,3.99S180.768,444.159,180.724,444.159Z",
    transform: "translate(-180.644 -436.18)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18340",
    "data-name": "Grupo 18340",
    transform: "translate(26.157 1.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18288",
    "data-name": "Grupo 18288",
    transform: "translate(0.311 0.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18287",
    "data-name": "Grupo 18287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18286",
    "data-name": "Grupo 18286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18285",
    "data-name": "Grupo 18285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18284",
    "data-name": "Grupo 18284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18283",
    "data-name": "Grupo 18283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18282",
    "data-name": "Grupo 18282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18281",
    "data-name": "Grupo 18281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18280",
    "data-name": "Grupo 18280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18279",
    "data-name": "Grupo 18279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13023",
    "data-name": "Trazado 13023",
    d: "M227.844,438.821l-.007-.014,4.588,3.7.04.033-.05.013-.611.161-3.874,1.016-.007,0-.007,0-3.511-1.488-.994-.426-.262-.114-.067-.03-.022-.011a.1.1,0,0,1,.024.007l.069.027.265.108,1,.413,3.518,1.471-.015,0,3.872-1.021.611-.161-.01.046-4.578-3.713-.007,0v-.009",
    transform: "translate(-223.06 -438.807)",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18297",
    "data-name": "Grupo 18297",
    transform: "translate(8.926 3.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18296",
    "data-name": "Grupo 18296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18295",
    "data-name": "Grupo 18295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18294",
    "data-name": "Grupo 18294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18293",
    "data-name": "Grupo 18293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18292",
    "data-name": "Grupo 18292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18291",
    "data-name": "Grupo 18291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18290",
    "data-name": "Grupo 18290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18289",
    "data-name": "Grupo 18289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13024",
    "data-name": "Trazado 13024",
    d: "M240.792,445.118l.25.235.336-.073-.147.311.173.3-.341-.043-.229.256-.064-.337-.314-.139.3-.165Z",
    transform: "translate(-240.457 -445.118)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18306",
    "data-name": "Grupo 18306",
    transform: "translate(4.664 4.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18305",
    "data-name": "Grupo 18305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18304",
    "data-name": "Grupo 18304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18303",
    "data-name": "Grupo 18303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18302",
    "data-name": "Grupo 18302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18301",
    "data-name": "Grupo 18301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18300",
    "data-name": "Grupo 18300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18299",
    "data-name": "Grupo 18299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18298",
    "data-name": "Grupo 18298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13025",
    "data-name": "Trazado 13025",
    d: "M232.047,448.064l.171.142.214-.06-.082.206.123.185-.222-.015-.138.174-.055-.215-.208-.077.188-.119Z",
    transform: "translate(-231.85 -448.064)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18315",
    "data-name": "Grupo 18315",
    transform: "translate(0 2.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18314",
    "data-name": "Grupo 18314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18313",
    "data-name": "Grupo 18313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18312",
    "data-name": "Grupo 18312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18311",
    "data-name": "Grupo 18311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18310",
    "data-name": "Grupo 18310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18309",
    "data-name": "Grupo 18309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18308",
    "data-name": "Grupo 18308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18307",
    "data-name": "Grupo 18307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13026",
    "data-name": "Trazado 13026",
    d: "M222.431,443.834l.272.017.168-.215.068.264.256.094-.23.146-.01.273-.21-.174-.262.075.1-.254Z",
    transform: "translate(-222.431 -443.637)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18324",
    "data-name": "Grupo 18324",
    transform: "translate(11.319 0.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18323",
    "data-name": "Grupo 18323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18322",
    "data-name": "Grupo 18322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18321",
    "data-name": "Grupo 18321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18320",
    "data-name": "Grupo 18320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18319",
    "data-name": "Grupo 18319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18318",
    "data-name": "Grupo 18318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18317",
    "data-name": "Grupo 18317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18316",
    "data-name": "Grupo 18316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13027",
    "data-name": "Trazado 13027",
    d: "M245.289,438.751l.272.017.168-.215.068.264.256.094-.23.146-.01.273-.21-.174-.262.075.1-.254Z",
    transform: "translate(-245.289 -438.553)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18333",
    "data-name": "Grupo 18333",
    transform: "translate(4.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18332",
    "data-name": "Grupo 18332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18331",
    "data-name": "Grupo 18331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18330",
    "data-name": "Grupo 18330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18329",
    "data-name": "Grupo 18329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18328",
    "data-name": "Grupo 18328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18327",
    "data-name": "Grupo 18327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18326",
    "data-name": "Grupo 18326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18325",
    "data-name": "Grupo 18325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13028",
    "data-name": "Trazado 13028",
    d: "M232.272,438.462l.174.011.107-.137.043.169.163.06-.147.093-.006.174-.134-.111-.167.048.064-.162Z",
    transform: "translate(-232.272 -438.336)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18339",
    "data-name": "Grupo 18339",
    transform: "translate(5.074 0.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18338",
    "data-name": "Grupo 18338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18337",
    "data-name": "Grupo 18337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18336",
    "data-name": "Grupo 18336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18335",
    "data-name": "Grupo 18335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18334",
    "data-name": "Grupo 18334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13029",
    "data-name": "Trazado 13029",
    d: "M239.305,439.045c0,.017-1.485-.032-3.314-.11s-3.313-.156-3.312-.174,1.485.031,3.315.11S239.306,439.027,239.305,439.045Z",
    transform: "translate(-232.679 -438.758)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18376",
    "data-name": "Grupo 18376",
    transform: "translate(2.075 8.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18346",
    "data-name": "Grupo 18346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18345",
    "data-name": "Grupo 18345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18344",
    "data-name": "Grupo 18344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18343",
    "data-name": "Grupo 18343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18342",
    "data-name": "Grupo 18342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13030",
    "data-name": "Trazado 13030",
    d: "M204.048,432.512H160.024a3.7,3.7,0,0,1,0-3.665h44.024A4.247,4.247,0,0,1,204.048,432.512Z",
    transform: "translate(-159.537 -428.847)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18351",
    "data-name": "Grupo 18351",
    transform: "translate(9.603 1.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18350",
    "data-name": "Grupo 18350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18349",
    "data-name": "Grupo 18349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18348",
    "data-name": "Grupo 18348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18347",
    "data-name": "Grupo 18347"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4603",
    "data-name": "Rect\\xE1ngulo 4603",
    width: 23.851,
    height: 1.334,
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18357",
    "data-name": "Grupo 18357",
    transform: "translate(1.415 0.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18356",
    "data-name": "Grupo 18356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18355",
    "data-name": "Grupo 18355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18354",
    "data-name": "Grupo 18354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18353",
    "data-name": "Grupo 18353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18352",
    "data-name": "Grupo 18352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13031",
    "data-name": "Trazado 13031",
    d: "M163.157,432.626a1.287,1.287,0,0,1-.348-.443,3.239,3.239,0,0,1-.233-2.652,1.289,1.289,0,0,1,.265-.5,4.127,4.127,0,0,1-.157.531,3.708,3.708,0,0,0,.226,2.565A4.141,4.141,0,0,1,163.157,432.626Z",
    transform: "translate(-162.395 -429.034)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18363",
    "data-name": "Grupo 18363",
    transform: "translate(2.368 0.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18362",
    "data-name": "Grupo 18362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18361",
    "data-name": "Grupo 18361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18360",
    "data-name": "Grupo 18360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18359",
    "data-name": "Grupo 18359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18358",
    "data-name": "Grupo 18358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13032",
    "data-name": "Trazado 13032",
    d: "M165.08,432.626a1.28,1.28,0,0,1-.348-.443,3.234,3.234,0,0,1-.233-2.652,1.288,1.288,0,0,1,.265-.5,4.131,4.131,0,0,1-.157.531,3.709,3.709,0,0,0,.226,2.565A4.243,4.243,0,0,1,165.08,432.626Z",
    transform: "translate(-164.319 -429.034)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18369",
    "data-name": "Grupo 18369",
    transform: "translate(42.725 0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18368",
    "data-name": "Grupo 18368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18367",
    "data-name": "Grupo 18367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18366",
    "data-name": "Grupo 18366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18365",
    "data-name": "Grupo 18365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18364",
    "data-name": "Grupo 18364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13033",
    "data-name": "Trazado 13033",
    d: "M245.825,432.458a5.517,5.517,0,0,0,.021-3.587,3.729,3.729,0,0,1-.021,3.587Z",
    transform: "translate(-245.821 -428.871)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18375",
    "data-name": "Grupo 18375",
    transform: "translate(41.898 0.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18374",
    "data-name": "Grupo 18374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18373",
    "data-name": "Grupo 18373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18372",
    "data-name": "Grupo 18372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18371",
    "data-name": "Grupo 18371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18370",
    "data-name": "Grupo 18370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13034",
    "data-name": "Trazado 13034",
    d: "M244.163,432.52c-.048-.011.137-.784.132-1.754s-.185-1.744-.137-1.754a5.371,5.371,0,0,1,0,3.509Z",
    transform: "translate(-244.15 -429.011)",
    fill: "#f5f5f5"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(87.403 34.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18461",
    "data-name": "Grupo 18461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18390",
    "data-name": "Grupo 18390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18389",
    "data-name": "Grupo 18389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18388",
    "data-name": "Grupo 18388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18382",
    "data-name": "Grupo 18382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18381",
    "data-name": "Grupo 18381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18380",
    "data-name": "Grupo 18380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18379",
    "data-name": "Grupo 18379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18378",
    "data-name": "Grupo 18378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13035",
    "data-name": "Trazado 13035",
    d: "M223.453,216.14l-61.858-.037a13.474,13.474,0,0,1-13.467-13.477l.03-155.08a13.475,13.475,0,0,1,13.483-13.472l61.858.036a13.475,13.475,0,0,1,13.467,13.478l-.03,155.081A13.474,13.474,0,0,1,223.453,216.14Z",
    transform: "translate(-148.128 -34.074)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18387",
    "data-name": "Grupo 18387",
    transform: "translate(3.96 5.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18386",
    "data-name": "Grupo 18386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18385",
    "data-name": "Grupo 18385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18384",
    "data-name": "Grupo 18384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18383",
    "data-name": "Grupo 18383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13036",
    "data-name": "Trazado 13036",
    d: "M227.333,45.281l-11.994-.007a2.98,2.98,0,0,0-2.913,3.043v2.176a2.979,2.979,0,0,1-2.913,3.042l-23.378-.013a2.983,2.983,0,0,1-2.912-3.046V48.3a2.983,2.983,0,0,0-2.912-3.046l-4.218,0-10.5-.006a9.437,9.437,0,0,0-9.442,9.436l-.03,151.369a9.438,9.438,0,0,0,9.432,9.439l61.735.036a9.436,9.436,0,0,0,9.442-9.435l.03-151.37A9.436,9.436,0,0,0,227.333,45.281Z",
    transform: "translate(-156.126 -45.244)",
    fill: "#fff"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18392",
    "data-name": "Grupo 18392",
    transform: "translate(3.872 29.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18391",
    "data-name": "Grupo 18391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13037",
    "data-name": "Trazado 13037",
    d: "M237.367,93.757c0,.071-18.228.129-40.708.129s-40.712-.058-40.712-.129,18.224-.129,40.712-.129S237.367,93.685,237.367,93.757Z",
    transform: "translate(-155.948 -93.628)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18393",
    "data-name": "Grupo 18393",
    transform: "translate(9.788 19.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13038",
    "data-name": "Trazado 13038",
    d: "M170.495,77.962a.246.246,0,0,1-.163-.061l-2.352-2.063a.247.247,0,0,1,0-.376l2.352-1.955a.248.248,0,0,1,.317.38l-2.129,1.77,2.134,1.872a.248.248,0,0,1-.163.434Z",
    transform: "translate(-167.895 -73.448)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18395",
    "data-name": "Grupo 18395",
    transform: "translate(29.49 21.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18394",
    "data-name": "Grupo 18394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13039",
    "data-name": "Trazado 13039",
    d: "M241.909,77.49c0,.071-7.662.129-17.112.129s-17.113-.058-17.113-.129,7.66-.129,17.113-.129S241.909,77.418,241.909,77.49Z",
    transform: "translate(-207.684 -77.361)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18396",
    "data-name": "Grupo 18396",
    transform: "translate(71.85 20.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13040",
    "data-name": "Trazado 13040",
    d: "M295.006,76.682a.889.889,0,1,1-.889-.889A.889.889,0,0,1,295.006,76.682Z",
    transform: "translate(-293.229 -75.793)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18397",
    "data-name": "Grupo 18397",
    transform: "translate(74.417 20.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13041",
    "data-name": "Trazado 13041",
    d: "M300.191,76.682a.889.889,0,1,1-.889-.889A.889.889,0,0,1,300.191,76.682Z",
    transform: "translate(-298.413 -75.793)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18398",
    "data-name": "Grupo 18398",
    transform: "translate(76.984 20.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13042",
    "data-name": "Trazado 13042",
    d: "M305.375,76.682a.889.889,0,1,1-.888-.889A.889.889,0,0,1,305.375,76.682Z",
    transform: "translate(-303.598 -75.793)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18399",
    "data-name": "Grupo 18399",
    transform: "translate(33.722 61.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13043",
    "data-name": "Trazado 13043",
    d: "M219.371,159.57c0,.574-.239.919-.637.919a.4.4,0,0,1-.421-.288.681.681,0,0,1-.6.288.844.844,0,0,1,0-1.685.69.69,0,0,1,.554.236v-.216h.368v1.128c0,.169.08.226.173.226.179,0,.279-.209.279-.6a1.17,1.17,0,0,0-1.274-1.187,1.241,1.241,0,1,0-.013,2.481,1.464,1.464,0,0,0,.644-.146l.09.265a1.735,1.735,0,0,1-.733.156,1.516,1.516,0,1,1,.013-3.028A1.447,1.447,0,0,1,219.371,159.57Zm-1.095.073a.492.492,0,1,0-.491.524A.476.476,0,0,0,218.276,159.643Z",
    transform: "translate(-216.23 -158.117)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18401",
    "data-name": "Grupo 18401",
    transform: "translate(39.574 63.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18400",
    "data-name": "Grupo 18400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13044",
    "data-name": "Trazado 13044",
    d: "M244.047,162.734c0,.071-3.582.129-8,.129s-8-.058-8-.129,3.581-.129,8-.129S244.047,162.663,244.047,162.734Z",
    transform: "translate(-228.047 -162.605)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18426",
    "data-name": "Grupo 18426",
    transform: "translate(17.213 86.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18406",
    "data-name": "Grupo 18406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18403",
    "data-name": "Grupo 18403",
    transform: "translate(4.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18402",
    "data-name": "Grupo 18402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13045",
    "data-name": "Trazado 13045",
    d: "M194.209,208.442a4.838,4.838,0,0,1-2.217,0,4.82,4.82,0,0,1,2.217,0Z",
    transform: "translate(-191.992 -208.313)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18405",
    "data-name": "Grupo 18405",
    transform: "translate(0 5.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18404",
    "data-name": "Grupo 18404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13046",
    "data-name": "Trazado 13046",
    d: "M194.837,219.278c0,.071-2.675.129-5.973.129s-5.974-.057-5.974-.129,2.674-.129,5.974-.129S194.837,219.206,194.837,219.278Z",
    transform: "translate(-182.89 -219.149)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18411",
    "data-name": "Grupo 18411",
    transform: "translate(20.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18408",
    "data-name": "Grupo 18408",
    transform: "translate(3.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18407",
    "data-name": "Grupo 18407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13047",
    "data-name": "Trazado 13047",
    d: "M238.083,208.442a44.912,44.912,0,0,1-6.8,0,44.738,44.738,0,0,1,6.8,0Z",
    transform: "translate(-231.287 -208.313)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18410",
    "data-name": "Grupo 18410",
    transform: "translate(0 5.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18409",
    "data-name": "Grupo 18409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13048",
    "data-name": "Trazado 13048",
    d: "M236.586,218.7c0,.071-2.739.129-6.116.129s-6.116-.057-6.116-.129,2.738-.129,6.116-.129S236.586,218.628,236.586,218.7Z",
    transform: "translate(-224.353 -218.571)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18416",
    "data-name": "Grupo 18416",
    transform: "translate(42.851 0.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18413",
    "data-name": "Grupo 18413",
    transform: "translate(0.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18412",
    "data-name": "Grupo 18412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13049",
    "data-name": "Trazado 13049",
    d: "M280.462,208.587a81.159,81.159,0,0,1-9.157,0,81.475,81.475,0,0,1,9.157,0Z",
    transform: "translate(-271.305 -208.458)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18415",
    "data-name": "Grupo 18415",
    transform: "translate(0 5.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18414",
    "data-name": "Grupo 18414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13050",
    "data-name": "Trazado 13050",
    d: "M281.23,219.133c0,.071-2.642.129-5.9.129s-5.9-.058-5.9-.129,2.642-.129,5.9-.129S281.23,219.062,281.23,219.133Z",
    transform: "translate(-269.427 -219.004)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18417",
    "data-name": "Grupo 18417",
    transform: "translate(2.719 10.502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4604",
    "data-name": "Rect\\xE1ngulo 4604",
    width: 36.087,
    height: 10.373,
    rx: 2.546,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18419",
    "data-name": "Grupo 18419",
    transform: "translate(11.232 15.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18418",
    "data-name": "Grupo 18418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13051",
    "data-name": "Trazado 13051",
    d: "M226.323,240.214c0,.071-4.646.129-10.375.129s-10.376-.057-10.376-.129,4.645-.129,10.376-.129S226.323,240.143,226.323,240.214Z",
    transform: "translate(-205.572 -240.085)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18420",
    "data-name": "Grupo 18420",
    transform: "translate(41.791 10.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4605",
    "data-name": "Rect\\xE1ngulo 4605",
    width: 10.311,
    height: 10.63,
    rx: 2.367,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18421",
    "data-name": "Grupo 18421",
    transform: "translate(45.835 15.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13052",
    "data-name": "Trazado 13052",
    d: "M275.455,238.769h2.222l-1.017,1.562Z",
    transform: "translate(-275.455 -238.769)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18423",
    "data-name": "Grupo 18423",
    transform: "translate(13.178 28.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18422",
    "data-name": "Grupo 18422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13053",
    "data-name": "Trazado 13053",
    d: "M235.13,265.921c0,.071-5.738.129-12.814.129s-12.815-.057-12.815-.129,5.736-.129,12.815-.129S235.13,265.849,235.13,265.921Z",
    transform: "translate(-209.502 -265.792)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18425",
    "data-name": "Grupo 18425",
    transform: "translate(8.614 33.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18424",
    "data-name": "Grupo 18424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13054",
    "data-name": "Trazado 13054",
    d: "M237.937,275.669c0,.071-8.429.129-18.825.129s-18.827-.058-18.827-.129,8.428-.129,18.827-.129S237.937,275.6,237.937,275.669Z",
    transform: "translate(-200.285 -275.54)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18428",
    "data-name": "Grupo 18428",
    transform: "translate(4.48 127.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18427",
    "data-name": "Grupo 18427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13055",
    "data-name": "Trazado 13055",
    d: "M237.814,292.574c0,.071-18.052.129-40.317.129s-40.321-.057-40.321-.129,18.049-.129,40.321-.129S237.814,292.5,237.814,292.574Z",
    transform: "translate(-157.176 -292.445)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18430",
    "data-name": "Grupo 18430",
    transform: "translate(45.465 128.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18429",
    "data-name": "Grupo 18429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13056",
    "data-name": "Trazado 13056",
    d: "M240.073,302.365a80.947,80.947,0,0,1,0-9.128,80.642,80.642,0,0,1,0,9.128Z",
    transform: "translate(-239.944 -293.237)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18440",
    "data-name": "Grupo 18440",
    transform: "translate(23.308 68.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18432",
    "data-name": "Grupo 18432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13146",
    "data-name": "Trazado 13146",
    d: "M4.166,0A4.166,4.166,0,1,1,0,4.166,4.166,4.166,0,0,1,4.166,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Completo",
    transform: "translate(10.986 5.082)",
    fill: "#e02a58",
    fontSize: 5,
    fontFamily: "Montserrat-ExtraBold, Montserrat",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "COMPLETO"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18439",
    "data-name": "Grupo 18439",
    transform: "translate(2.285 2.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18438",
    "data-name": "Grupo 18438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18437",
    "data-name": "Grupo 18437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18436",
    "data-name": "Grupo 18436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18435",
    "data-name": "Grupo 18435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18434",
    "data-name": "Grupo 18434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18433",
    "data-name": "Grupo 18433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13064",
    "data-name": "Trazado 13064",
    d: "M199.814,180.1l.535-.535,1.032.917,2.025-1.949.5.535-2.6,2.445Z",
    transform: "translate(-199.814 -178.533)",
    fill: "#fff"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18441",
    "data-name": "Grupo 18441",
    transform: "translate(3.872 137.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13065",
    "data-name": "Trazado 13065",
    d: "M197.449,350.007l-32.676-.013a8.826,8.826,0,0,1-8.826-8.826v-29.5h41.5Z",
    transform: "translate(-155.947 -311.67)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18442",
    "data-name": "Grupo 18442",
    transform: "translate(44.979 137.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13066",
    "data-name": "Trazado 13066",
    d: "M269.5,350.086l-30.534-.08V311.67h39.7v29.248A9.365,9.365,0,0,1,269.5,350.086Z",
    transform: "translate(-238.964 -311.67)",
    fill: "#1b202c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18444",
    "data-name": "Grupo 18444",
    transform: "translate(4.486 137.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18443",
    "data-name": "Grupo 18443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13067",
    "data-name": "Trazado 13067",
    d: "M237.819,311.539c0,.071-18.051.129-40.314.129s-40.318-.058-40.318-.129,18.048-.129,40.318-.129S237.819,311.467,237.819,311.539Z",
    transform: "translate(-157.187 -311.41)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18446",
    "data-name": "Grupo 18446",
    transform: "translate(5.393 152.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18445",
    "data-name": "Grupo 18445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13068",
    "data-name": "Trazado 13068",
    d: "M197.814,349.633a.526.526,0,0,1-.111-.07l-.31-.225-1.18-.884-4.309-3.289c-.907-.687-1.9-1.481-2.967-2.261a1.742,1.742,0,0,0-1.856.063,8.005,8.005,0,0,0-.771.738l-.787.8-6.921,7-.427.431-.079.08-.09-.067-4-2.985-1.9-1.419a1.788,1.788,0,0,0-1.988-.332,3.434,3.434,0,0,0-.824.657l-.779.726-1.49,1.386-2.675,2.483-3.88,3.576L159.4,357l-.28.245a.471.471,0,0,1-.1.077.464.464,0,0,1,.084-.1l.263-.263,1.029-1,3.824-3.635,2.654-2.506,1.482-1.4.775-.73.4-.372a1.97,1.97,0,0,1,.482-.329,1.941,1.941,0,0,1,1.164-.171,1.965,1.965,0,0,1,.577.186,3.393,3.393,0,0,1,.5.332l1.9,1.414,4.008,2.98-.169.012.427-.431,6.935-6.988.79-.794a7.92,7.92,0,0,1,.809-.761,1.96,1.96,0,0,1,2.093-.06c1.1.817,2.059,1.6,2.97,2.3l4.259,3.354,1.15.923.3.245C197.785,349.6,197.817,349.63,197.814,349.633Z",
    transform: "translate(-159.02 -342.447)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18448",
    "data-name": "Grupo 18448",
    transform: "translate(20.667 143.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18447",
    "data-name": "Grupo 18447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13069",
    "data-name": "Trazado 13069",
    d: "M197.188,327.2c-.029,0-.014-.321-.161-.866a3.586,3.586,0,0,0-1.315-1.921,3.5,3.5,0,0,0-3.306-.48,3.448,3.448,0,0,0-1.611,1.216,3.462,3.462,0,0,0,0,4.1,3.442,3.442,0,0,0,1.611,1.216,3.5,3.5,0,0,0,3.307-.48,3.588,3.588,0,0,0,1.315-1.921c.147-.546.132-.868.161-.866a.763.763,0,0,1,.014.231,2.818,2.818,0,0,1-.078.66,3.58,3.58,0,0,1-1.3,2.042,3.638,3.638,0,0,1-1.548.707,3.7,3.7,0,0,1-1.95-.149,3.656,3.656,0,0,1-1.733-1.289,3.694,3.694,0,0,1,0-4.4,3.68,3.68,0,0,1,5.231-.731,3.581,3.581,0,0,1,1.3,2.042,2.8,2.8,0,0,1,.078.66A.768.768,0,0,1,197.188,327.2Z",
    transform: "translate(-189.864 -323.49)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18450",
    "data-name": "Grupo 18450",
    transform: "translate(46.158 151.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18449",
    "data-name": "Grupo 18449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13070",
    "data-name": "Trazado 13070",
    d: "M278.657,347.2a.474.474,0,0,1-.107-.07l-.3-.225-1.137-.885-4.151-3.294c-.875-.687-1.834-1.485-2.858-2.261a1.611,1.611,0,0,0-1.795.092,9.485,9.485,0,0,0-.737.741l-.754.795-6.631,6.975-.414.435-.08.084-.092-.071-3.858-2.99-1.831-1.421a1.658,1.658,0,0,0-1.925-.309,3.8,3.8,0,0,0-.787.667l-.748.724-1.43,1.383-2.567,2.476-3.723,3.567-1.02.959-.269.245a.481.481,0,0,1-.1.077.455.455,0,0,1,.08-.1l.252-.263.986-.993,3.667-3.625,2.545-2.5,1.421-1.392.744-.728.38-.371a2.028,2.028,0,0,1,.458-.339,1.826,1.826,0,0,1,1.136-.192,1.864,1.864,0,0,1,.566.183,3.272,3.272,0,0,1,.481.333l1.835,1.416,3.862,2.985-.172.013.414-.435,6.646-6.962.757-.791a9.278,9.278,0,0,1,.771-.763,1.832,1.832,0,0,1,2.041-.093c1.066.817,1.984,1.6,2.862,2.3l4.1,3.358,1.107.923.284.245C278.629,347.165,278.66,347.2,278.657,347.2Z",
    transform: "translate(-241.344 -340.014)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18452",
    "data-name": "Grupo 18452",
    transform: "translate(59.314 142.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18451",
    "data-name": "Grupo 18451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13071",
    "data-name": "Trazado 13071",
    d: "M275.238,325c-.029,0-.015-.321-.161-.867a3.587,3.587,0,0,0-1.315-1.921,3.5,3.5,0,0,0-3.307-.48,3.446,3.446,0,0,0-1.61,1.216,3.463,3.463,0,0,0,0,4.1,3.441,3.441,0,0,0,1.611,1.216,3.5,3.5,0,0,0,3.307-.48,3.588,3.588,0,0,0,1.315-1.921c.147-.546.132-.868.161-.866a.785.785,0,0,1,.014.231,2.854,2.854,0,0,1-.078.66,3.583,3.583,0,0,1-1.3,2.042,3.641,3.641,0,0,1-1.548.707,3.7,3.7,0,0,1-1.95-.149,3.659,3.659,0,0,1-1.733-1.289,3.693,3.693,0,0,1,0-4.4,3.661,3.661,0,0,1,1.733-1.289,3.7,3.7,0,0,1,1.95-.148,3.637,3.637,0,0,1,1.548.707,3.583,3.583,0,0,1,1.3,2.042,2.857,2.857,0,0,1,.078.66A.791.791,0,0,1,275.238,325Z",
    transform: "translate(-267.913 -321.292)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18460",
    "data-name": "Grupo 18460",
    transform: "translate(33.987 36.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18453",
    "data-name": "Grupo 18453",
    transform: "translate(0.149 0.108)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_270",
    "data-name": "Elipse 270",
    cx: 11.469,
    cy: 11.469,
    r: 11.469,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18454",
    "data-name": "Grupo 18454",
    transform: "translate(4.206 13.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13072",
    "data-name": "Trazado 13072",
    d: "M240.087,142.262a7.3,7.3,0,0,0-7.413-6.513,7.541,7.541,0,0,0-7.415,6.538,10.2,10.2,0,0,0,7.415,2.743A10.547,10.547,0,0,0,240.087,142.262Z",
    transform: "translate(-225.26 -135.749)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18455",
    "data-name": "Grupo 18455",
    transform: "translate(6.464 4.898)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_271",
    "data-name": "Elipse 271",
    cx: 4.497,
    cy: 4.497,
    r: 4.497,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 0, 8.878)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18457",
    "data-name": "Grupo 18457",
    transform: "translate(4.318 5.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18456",
    "data-name": "Grupo 18456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13073",
    "data-name": "Trazado 13073",
    d: "M240.148,133.371a8.963,8.963,0,0,0-.7-2.119,7.063,7.063,0,0,0-1.621-1.993,8.892,8.892,0,0,0-2.93-1.643l-.233-.077.213-.114a4.447,4.447,0,0,0,1.792-1.789,4.372,4.372,0,1,0-7.708-.018,4.587,4.587,0,0,0,.784,1.051,5.68,5.68,0,0,0,1,.76l.2.127-.227.061a6.866,6.866,0,0,0-2.931,1.62,7.455,7.455,0,0,0-1.535,2.073,8.886,8.886,0,0,0-.6,1.546c-.055.184-.087.327-.111.422a.692.692,0,0,1-.041.145.458.458,0,0,1,.009-.151,4.375,4.375,0,0,1,.083-.432,7.884,7.884,0,0,1,.559-1.583,7.384,7.384,0,0,1,1.525-2.143,6.978,6.978,0,0,1,2.992-1.7l-.029.187a5.822,5.822,0,0,1-1.038-.777,4.759,4.759,0,0,1-.832-1.1,4.619,4.619,0,0,1,.983-5.628,4.6,4.6,0,0,1,6.165.008,4.615,4.615,0,0,1,.963,5.639,4.646,4.646,0,0,1-1.9,1.863l-.019-.192a8.929,8.929,0,0,1,2.981,1.716,7.025,7.025,0,0,1,1.617,2.065,5.92,5.92,0,0,1,.353.9,3.935,3.935,0,0,1,.17.69c.025.175.046.318.063.434A.556.556,0,0,1,240.148,133.371Z",
    transform: "translate(-225.486 -118.916)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18459",
    "data-name": "Grupo 18459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18458",
    "data-name": "Grupo 18458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13074",
    "data-name": "Trazado 13074",
    d: "M239.851,119.527a1.037,1.037,0,0,1-.023-.186l-.04-.544-.026-.4c-.016-.147-.049-.306-.075-.479a8.483,8.483,0,0,0-.243-1.181,10.975,10.975,0,0,0-1.277-3.034,11.377,11.377,0,0,0-13.664-4.844,10.456,10.456,0,0,0-2.872,1.547,10.4,10.4,0,0,0-2.4,2.411,11.012,11.012,0,0,0-1.622,3.128,11.252,11.252,0,0,0,0,7.164,11,11,0,0,0,1.622,3.128,10.37,10.37,0,0,0,2.4,2.412A10.432,10.432,0,0,0,224.5,130.2a11.406,11.406,0,0,0,13.664-4.845,10.978,10.978,0,0,0,1.277-3.034,8.4,8.4,0,0,0,.243-1.181c.027-.173.059-.332.075-.478l.026-.4c.017-.229.03-.409.04-.544a1.047,1.047,0,0,1,.023-.186,1.019,1.019,0,0,1,0,.186c0,.136-.009.317-.015.547,0,.122-.009.256-.014.4s-.041.308-.063.483a8.1,8.1,0,0,1-.222,1.195,10.853,10.853,0,0,1-1.25,3.083,11.557,11.557,0,0,1-7.78,5.483,11.61,11.61,0,0,1-6.089-.488,10.653,10.653,0,0,1-2.939-1.573,10.638,10.638,0,0,1-2.457-2.461,11.234,11.234,0,0,1-1.662-3.2,11.489,11.489,0,0,1,0-7.325,11.23,11.23,0,0,1,1.662-3.2,10.608,10.608,0,0,1,2.457-2.46,10.675,10.675,0,0,1,2.938-1.573,11.608,11.608,0,0,1,6.089-.488,11.557,11.557,0,0,1,7.78,5.482,10.863,10.863,0,0,1,1.25,3.084,8.107,8.107,0,0,1,.222,1.2c.023.174.051.335.063.483s.01.282.014.4c.006.23.011.411.015.547A1.012,1.012,0,0,1,239.851,119.527Z",
    transform: "translate(-216.765 -107.951)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(27.839 131.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18479",
    "data-name": "Grupo 18479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18462",
    "data-name": "Grupo 18462",
    transform: "translate(34.341 2.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13075",
    "data-name": "Trazado 13075",
    d: "M120.587,236.53c-6.022,3.12-10.64,8.491-13.961,14.405s-5.461,12.4-7.581,18.846L97.19,303.008c7.008-11.921,12.632-25.936,14.152-39.681l-4.664-.415c3.127-.477,5.751-2.743,7.421-5.429a33.05,33.05,0,0,0,3.368-8.833l-5.69.846A21.084,21.084,0,0,0,120.587,236.53Z",
    transform: "translate(-97.19 -236.53)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18463",
    "data-name": "Grupo 18463",
    transform: "translate(34.341 2.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13076",
    "data-name": "Trazado 13076",
    d: "M120.587,236.53c-6.022,3.12-10.64,8.491-13.961,14.405s-5.461,12.4-7.581,18.846L97.19,303.008c7.008-11.921,12.632-25.936,14.152-39.681l-4.664-.415c3.127-.477,5.751-2.743,7.421-5.429a33.05,33.05,0,0,0,3.368-8.833l-5.69.846A21.084,21.084,0,0,0,120.587,236.53Z",
    transform: "translate(-97.19 -236.53)",
    fill: "#1b202c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18464",
    "data-name": "Grupo 18464",
    transform: "translate(18.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13077",
    "data-name": "Trazado 13077",
    d: "M79.736,307.99S64.525,289.784,64.7,272.405h6.144s-6.674-4.389-6.146-6.847.7-11.762.7-11.762l5.617,1.4s-4.213-2.106-4.74-5.442,1.229-18.784,1.229-18.784,6.846,7.2,8.953,14.571,7.636,15.975,6.012,38.445S79.736,307.99,79.736,307.99Z",
    transform: "translate(-64.67 -230.975)",
    fill: "#e02a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18465",
    "data-name": "Grupo 18465",
    transform: "translate(41.008 19.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13078",
    "data-name": "Trazado 13078",
    d: "M110.661,329.917s16.479-10.978,20.14-24.989l-4.94-1.344s6.326-2.068,6.439-4.159,2.007-9.61,2.007-9.61l-4.823-.1s3.848-.771,5-3.338,3.122-15.371,3.122-15.371-7.079,4.289-10.386,9.755-9.635,11.173-13.245,29.593S110.661,329.917,110.661,329.917Z",
    transform: "translate(-110.655 -271.005)",
    fill: "#e02a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18467",
    "data-name": "Grupo 18467",
    transform: "translate(25.231 15.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18466",
    "data-name": "Grupo 18466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13079",
    "data-name": "Trazado 13079",
    d: "M78.795,263.031a1.1,1.1,0,0,1,.053.189l.131.561.48,2.161c.21.938.455,2.088.72,3.428s.585,2.861.892,4.552c.65,3.376,1.336,7.411,2.044,11.9.685,4.493,1.37,9.444,1.978,14.654s1.06,10.19,1.418,14.721c.336,4.533.589,8.619.726,12.054.086,1.716.127,3.271.169,4.635s.072,2.54.081,3.5.02,1.693.026,2.213v.575a1.1,1.1,0,0,1-.009.2,1.091,1.091,0,0,1-.017-.2l-.026-.575c-.017-.52-.042-1.262-.074-2.211s-.064-2.135-.125-3.5-.11-2.917-.207-4.632c-.16-3.432-.432-7.515-.781-12.044-.371-4.528-.841-9.5-1.436-14.711s-1.285-10.155-1.957-14.647c-.694-4.489-1.361-8.525-1.988-11.9-.3-1.692-.6-3.217-.855-4.557s-.482-2.495-.676-3.436l-.433-2.17-.106-.566A1.075,1.075,0,0,1,78.795,263.031Z",
    transform: "translate(-78.794 -263.031)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18468",
    "data-name": "Grupo 18468",
    transform: "translate(0 45.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13080",
    "data-name": "Trazado 13080",
    d: "M59.032,365.713s-13.919-15.793-18.241-25.34l3.263-1.394a8.455,8.455,0,0,1-6.622-2.169,25.075,25.075,0,0,1-4.5-5.575l4.3-.726a15.978,15.978,0,0,1-9.39-7.275c5.072.834,9.66,3.62,13.441,7.1a66.941,66.941,0,0,1,8.145,9.438,32.129,32.129,0,0,1,3.163,5.2C54.927,349.81,59.04,359.913,59.032,365.713Z",
    transform: "translate(-27.839 -323.234)",
    fill: "#1b202c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18470",
    "data-name": "Grupo 18470",
    transform: "translate(37.322 29.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18469",
    "data-name": "Grupo 18469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13081",
    "data-name": "Trazado 13081",
    d: "M127.262,289.569a.868.868,0,0,1-.065.16l-.215.458-.849,1.751c-.374.758-.828,1.687-1.341,2.771s-1.116,2.312-1.745,3.686c-1.285,2.734-2.762,6.015-4.35,9.681s-3.25,7.731-4.918,12.028-3.149,8.435-4.454,12.21-2.406,7.2-3.295,10.089c-.459,1.44-.84,2.752-1.188,3.9s-.639,2.141-.872,2.953l-.55,1.867-.149.484a.846.846,0,0,1-.059.162.853.853,0,0,1,.034-.169l.124-.491.5-1.88c.218-.817.493-1.814.83-2.966s.7-2.47,1.152-3.913c.868-2.9,1.964-6.325,3.244-10.113s2.779-7.921,4.439-12.227,3.353-8.361,4.94-12.029,3.1-6.938,4.4-9.664c.64-1.37,1.253-2.592,1.78-3.671s.994-2,1.381-2.754l.893-1.73.238-.447A.858.858,0,0,1,127.262,289.569Z",
    transform: "translate(-103.21 -289.569)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18472",
    "data-name": "Grupo 18472",
    transform: "translate(22.181 67.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18471",
    "data-name": "Grupo 18471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13082",
    "data-name": "Trazado 13082",
    d: "M82.826,395.164a1.29,1.29,0,0,1-.064-.291c-.035-.219-.079-.5-.134-.839-.052-.364-.12-.81-.215-1.325s-.183-1.1-.322-1.747c-.249-1.293-.606-2.82-1.061-4.5s-1.047-3.5-1.751-5.381-1.488-3.629-2.243-5.2-1.51-2.944-2.178-4.079c-.32-.575-.643-1.077-.913-1.525s-.512-.828-.714-1.136l-.454-.718a1.3,1.3,0,0,1-.144-.26,1.276,1.276,0,0,1,.187.231l.495.691c.215.3.472.672.752,1.115s.616.938.948,1.509c.69,1.126,1.451,2.505,2.234,4.067s1.553,3.325,2.271,5.211,1.28,3.724,1.739,5.41.784,3.227,1.011,4.528c.128.648.205,1.241.285,1.759s.136.967.173,1.334c.035.345.063.624.086.846A1.274,1.274,0,0,1,82.826,395.164Z",
    transform: "translate(-72.633 -368.166)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18473",
    "data-name": "Grupo 18473",
    transform: "translate(20.277 91.216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4606",
    "data-name": "Rect\\xE1ngulo 4606",
    width: 30.464,
    height: 6.214,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18474",
    "data-name": "Grupo 18474",
    transform: "translate(23.18 97.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13083",
    "data-name": "Trazado 13083",
    d: "M74.65,427.735l3.3,20.9H96.354l3.071-20.9Z",
    transform: "translate(-74.65 -427.735)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18476",
    "data-name": "Grupo 18476",
    transform: "translate(23.131 97.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18475",
    "data-name": "Grupo 18475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13084",
    "data-name": "Trazado 13084",
    d: "M100.293,427.6c0,.071-5.763.129-12.87.129s-12.872-.057-12.872-.129,5.762-.129,12.872-.129S100.293,427.532,100.293,427.6Z",
    transform: "translate(-74.551 -427.475)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(161.045 71.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18839",
    "data-name": "Grupo 18839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18490",
    "data-name": "Grupo 18490",
    transform: "translate(4.748 88.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18485",
    "data-name": "Grupo 18485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18484",
    "data-name": "Grupo 18484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18483",
    "data-name": "Grupo 18483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18482",
    "data-name": "Grupo 18482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18481",
    "data-name": "Grupo 18481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18480",
    "data-name": "Grupo 18480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13086",
    "data-name": "Trazado 13086",
    d: "M368.053,289.457s5.053,8.386,5.8,16.369-4.579,72.479-4.579,72.479H306.437s16.833-79.644,22.344-84.755l.377-5.3Z",
    transform: "translate(-306.437 -288.251)",
    fill: "#1b202c"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18487",
    "data-name": "Grupo 18487",
    transform: "translate(0.632 7.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18486",
    "data-name": "Grupo 18486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13087",
    "data-name": "Trazado 13087",
    d: "M371.38,303.6a9.12,9.12,0,0,1-.023,1.124,13.483,13.483,0,0,1-.6,3.167,14.555,14.555,0,0,1-2.346,4.521,13.7,13.7,0,0,1-2.226,2.29,23.169,23.169,0,0,1-2.975,1.989c-1.083.63-2.241,1.245-3.4,1.96a14.726,14.726,0,0,0-3.286,2.634,12.1,12.1,0,0,0-2.238,3.888,24.747,24.747,0,0,0-1.022,4.692c-.224,1.635-.366,3.324-.591,5.045a23.48,23.48,0,0,1-1.19,5.18,11.682,11.682,0,0,1-3.042,4.571,18.052,18.052,0,0,1-4.786,3.033c-3.482,1.592-7.108,2.608-10.183,4.467a13.548,13.548,0,0,0-3.889,3.478,16.007,16.007,0,0,0-2.2,4.511c-1.01,3.138-1.434,6.274-2.259,9.109l-.321,1.05-.359,1.018c-.281.656-.532,1.311-.863,1.913-.294.622-.664,1.185-1,1.751l-.555.8-.275.393-.3.37a21.331,21.331,0,0,1-9.51,6.875,20.162,20.162,0,0,1-3.116.829l-.829.124c-.187.026-.283.034-.283.034s.094-.025.28-.06l.823-.149a21.563,21.563,0,0,0,3.091-.872,21.415,21.415,0,0,0,9.4-6.893l.293-.368.271-.39.547-.8c.328-.563.693-1.122.98-1.738.326-.6.572-1.246.848-1.9l.352-1.01.315-1.043c.813-2.819,1.227-5.954,2.24-9.124a16.215,16.215,0,0,1,2.23-4.583,13.753,13.753,0,0,1,3.956-3.548c3.114-1.886,6.751-2.9,10.206-4.485a17.834,17.834,0,0,0,4.72-2.987,11.432,11.432,0,0,0,2.98-4.472,23.318,23.318,0,0,0,1.182-5.123c.227-1.712.372-3.4.6-5.045a24.906,24.906,0,0,1,1.043-4.735,12.288,12.288,0,0,1,2.293-3.955,14.87,14.87,0,0,1,3.34-2.661c1.169-.715,2.331-1.325,3.412-1.948a23.176,23.176,0,0,0,2.963-1.958,13.6,13.6,0,0,0,2.216-2.251,14.577,14.577,0,0,0,2.363-4.464,14,14,0,0,0,.645-3.14c.043-.366.043-.647.054-.835S371.38,303.6,371.38,303.6Z",
    transform: "translate(-307.713 -303.599)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18489",
    "data-name": "Grupo 18489",
    transform: "translate(7.98 13.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18488",
    "data-name": "Grupo 18488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13088",
    "data-name": "Trazado 13088",
    d: "M380.636,315.441s.036.083.1.25a5.977,5.977,0,0,1,.212.756,7.373,7.373,0,0,1-.054,3,10.718,10.718,0,0,1-2.056,4.283,27.608,27.608,0,0,1-4.555,4.371,27.416,27.416,0,0,0-5.415,5.32,10.414,10.414,0,0,0-1.67,3.842,29.94,29.94,0,0,0-.481,4.468,23.613,23.613,0,0,1-.662,4.715,20.738,20.738,0,0,1-1.807,4.629,21.159,21.159,0,0,1-6.971,7.672c-3.025,1.975-6.438,2.928-9.431,4.422a15.7,15.7,0,0,0-4.054,2.739,12.866,12.866,0,0,0-2.652,3.849,51.547,51.547,0,0,0-2.509,8.374,34.589,34.589,0,0,1-1.2,3.8,16.53,16.53,0,0,1-1.732,3.25,13.742,13.742,0,0,1-2.237,2.489c-.386.363-.808.66-1.2.967-.418.271-.807.56-1.219.779a14.595,14.595,0,0,1-7.434,2.045l-.783-.038c-.176-.01-.266-.022-.266-.022s.091-.006.267,0l.781.012a15.8,15.8,0,0,0,2.975-.36,15.119,15.119,0,0,0,4.386-1.757c.407-.22.789-.51,1.2-.78.386-.307.8-.6,1.181-.964a13.659,13.659,0,0,0,2.2-2.471,16.455,16.455,0,0,0,1.7-3.219,34.7,34.7,0,0,0,1.182-3.782,51.283,51.283,0,0,1,2.5-8.42,13.1,13.1,0,0,1,2.7-3.926,15.918,15.918,0,0,1,4.113-2.788c3.02-1.509,6.422-2.464,9.4-4.411a20.951,20.951,0,0,0,6.889-7.576,20.532,20.532,0,0,0,1.792-4.57,23.422,23.422,0,0,0,.663-4.669,30.024,30.024,0,0,1,.5-4.5,10.618,10.618,0,0,1,1.715-3.914,27.422,27.422,0,0,1,5.476-5.34,27.7,27.7,0,0,0,4.556-4.317,10.707,10.707,0,0,0,2.072-4.216,7.5,7.5,0,0,0,.1-2.974C380.762,315.783,380.616,315.447,380.636,315.441Z",
    transform: "translate(-322.553 -315.441)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18495",
    "data-name": "Grupo 18495",
    transform: "translate(7.032 54.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18494",
    "data-name": "Grupo 18494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18493",
    "data-name": "Grupo 18493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18492",
    "data-name": "Grupo 18492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18491",
    "data-name": "Grupo 18491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13089",
    "data-name": "Trazado 13089",
    d: "M311.049,222.027s4.077,28.1,10.343,30.837c3.16,1.378,5.7.193,7.432-2.992s6.14-26.157,6.14-26.157l-12.2-.285-.456,4.57-4.7-8.751Z",
    transform: "translate(-311.049 -219.249)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18501",
    "data-name": "Grupo 18501",
    transform: "translate(13.595 54.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18500",
    "data-name": "Grupo 18500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18499",
    "data-name": "Grupo 18499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18498",
    "data-name": "Grupo 18498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18497",
    "data-name": "Grupo 18497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18496",
    "data-name": "Grupo 18496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13090",
    "data-name": "Trazado 13090",
    d: "M335.72,240.378a.981.981,0,0,0-.1-.222l-.336-.614-1.245-2.253c-1.05-1.9-2.492-4.535-4.065-7.453l-4-7.491-1.2-2.275-.335-.615a.95.95,0,0,0-.131-.207.992.992,0,0,0,.089.228l.3.635c.26.55.65,1.338,1.138,2.309.978,1.942,2.363,4.607,3.94,7.526s3.04,5.54,4.127,7.423c.543.942.993,1.7,1.31,2.217l.373.593A.95.95,0,0,0,335.72,240.378Z",
    transform: "translate(-324.302 -219.249)",
    fill: "#6f4c47"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18557",
    "data-name": "Grupo 18557",
    transform: "translate(16.932 40.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18544",
    "data-name": "Grupo 18544",
    transform: "translate(10.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18506",
    "data-name": "Grupo 18506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18505",
    "data-name": "Grupo 18505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18504",
    "data-name": "Grupo 18504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18503",
    "data-name": "Grupo 18503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18502",
    "data-name": "Grupo 18502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13091",
    "data-name": "Trazado 13091",
    d: "M392.319,214.1l-3.481,15.572,1.647,10.451H352.226l2.5-48.787,9.539-.811,23.3,3.934Z",
    transform: "translate(-352.226 -190.521)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18511",
    "data-name": "Grupo 18511",
    transform: "translate(30.36 3.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18510",
    "data-name": "Grupo 18510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18509",
    "data-name": "Grupo 18509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18508",
    "data-name": "Grupo 18508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18507",
    "data-name": "Grupo 18507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13092",
    "data-name": "Trazado 13092",
    d: "M413.538,197.857s9.966-.914,14.713,5.866c2.9,4.149,6.983,13.678,6.983,13.678l-13.266,2.287Z",
    transform: "translate(-413.538 -197.816)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18512",
    "data-name": "Grupo 18512",
    transform: "translate(27.06 19.219)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13093",
    "data-name": "Trazado 13093",
    d: "M416.213,233.875a8.08,8.08,0,0,0-7.376-4.537,2.081,2.081,0,0,0-1.765.738,2.28,2.28,0,0,0,.1,2.01,3.775,3.775,0,0,0,1.587,2.147,12.05,12.05,0,0,0,1.928.477,6.117,6.117,0,0,1,2.053,1.3,4.281,4.281,0,0,1,1.877,2.91c.647,2.546,1.161,7.8,1.807,10.344l.713-2.194.052-6.28C417.209,238.441,417.21,236,416.213,233.875Z",
    transform: "translate(-406.873 -229.335)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18518",
    "data-name": "Grupo 18518",
    transform: "translate(24.505 36.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18517",
    "data-name": "Grupo 18517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18516",
    "data-name": "Grupo 18516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18515",
    "data-name": "Grupo 18515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18514",
    "data-name": "Grupo 18514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18513",
    "data-name": "Grupo 18513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13094",
    "data-name": "Trazado 13094",
    d: "M401.715,264.719",
    transform: "translate(-401.715 -264.719)",
    fill: "none",
    stroke: "#4e585d",
    strokeWidth: 0.05
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18524",
    "data-name": "Grupo 18524",
    transform: "translate(33.592 35.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18523",
    "data-name": "Grupo 18523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18522",
    "data-name": "Grupo 18522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18521",
    "data-name": "Grupo 18521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18520",
    "data-name": "Grupo 18520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18519",
    "data-name": "Grupo 18519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13095",
    "data-name": "Trazado 13095",
    d: "M420.065,262.326",
    transform: "translate(-420.065 -262.326)",
    fill: "none",
    stroke: "#4e585d",
    strokeWidth: 0.05
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18536",
    "data-name": "Grupo 18536",
    transform: "translate(7.815 37.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18535",
    "data-name": "Grupo 18535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18534",
    "data-name": "Grupo 18534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18533",
    "data-name": "Grupo 18533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18532",
    "data-name": "Grupo 18532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18531",
    "data-name": "Grupo 18531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13097",
    "data-name": "Trazado 13097",
    d: "M368.008,266.1c.018-.061,5.432,1.481,12.091,3.445s12.044,3.608,12.025,3.67-5.431-1.481-12.092-3.445S367.99,266.161,368.008,266.1Z",
    transform: "translate(-368.008 -266.097)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18543",
    "data-name": "Grupo 18543",
    transform: "translate(11.094 38.41)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18542",
    "data-name": "Grupo 18542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18541",
    "data-name": "Grupo 18541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18540",
    "data-name": "Grupo 18540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18539",
    "data-name": "Grupo 18539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18538",
    "data-name": "Grupo 18538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13099",
    "data-name": "Trazado 13099",
    d: "M394.011,273.744l-.14.054a19.113,19.113,0,0,1-9.891-1.165,59.2,59.2,0,0,1-9.349-4.542Z",
    transform: "translate(-374.631 -268.091)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18856",
    "data-name": "Grupo 18856",
    transform: "translate(13.728 25.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4839",
    "data-name": "Trazado 4839",
    d: "M11.282,2.808A9.4,9.4,0,0,0,6.959.276,5.906,5.906,0,0,0,2.31.7v.01A4.535,4.535,0,0,0,0,4.961,7.489,7.489,0,0,0,1.356,9.249,10.476,10.476,0,0,0,2.8,10.966a8.675,8.675,0,0,0,6.113,2.707,4.76,4.76,0,0,0,4.315-2.192,4.9,4.9,0,0,0,.737-2.232,6.17,6.17,0,0,0-.206-2.2,9.061,9.061,0,0,0-2.477-4.239M7.056.984a8.2,8.2,0,0,1,3.823,2.2,8.088,8.088,0,0,1,2.172,3.745,5.521,5.521,0,0,1,.089,2.318,4.242,4.242,0,0,1-.639,1.523,4.126,4.126,0,0,1-3.765,1.765,7.486,7.486,0,0,1-5.13-2.328,9.476,9.476,0,0,1-.855-.96A6.765,6.765,0,0,1,1.179,5.136,3.935,3.935,0,0,1,3.056,1.45V1.44a4.985,4.985,0,0,1,4-.456",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4840",
    "data-name": "Trazado 4840",
    d: "M.262.013C.055-.036-.024.052.006.246l.079.5a.424.424,0,0,0,.373.359l.531.107c.187.039.265-.049.226-.243L1.136.489A.447.447,0,0,0,.773.13Z",
    transform: "translate(8.849 3.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4841",
    "data-name": "Trazado 4841",
    d: "M1.074,1.323c.236.039.334-.049.314-.252L1.319.537A.416.416,0,0,0,.946.149L.326.013C.091-.035-.017.052,0,.255L.062.8c.01.213.137.339.383.388Z",
    transform: "translate(4.469 2.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4842",
    "data-name": "Trazado 4842",
    d: "M1.349,1.069,1.231.448C1.182.205,1.064.079.848.07L.278,0C.062-.017-.037.089.013.322l.108.64a.413.413,0,0,0,.4.388L1.1,1.4c.207.02.295-.1.246-.33",
    transform: "translate(9.825 8.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4843",
    "data-name": "Trazado 4843",
    d: "M1.156.45A.4.4,0,0,0,.8.1L.281.013C.065-.036-.024.052.005.246L.1.78a.424.424,0,0,0,.373.368l.54.087c.2.029.275-.058.246-.252Z",
    transform: "translate(9.066 4.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4844",
    "data-name": "Trazado 4844",
    d: "M.012.267l.1.582a.417.417,0,0,0,.384.369l.54.068c.207.029.3-.058.256-.271L1.182.462A.4.4,0,0,0,.818.1L.287.006C.061-.024-.037.064.012.267",
    transform: "translate(9.305 5.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4845",
    "data-name": "Trazado 4845",
    d: "M1.358.517A.436.436,0,0,0,.975.129L.336.013C.1-.035-.018.052,0,.265L.051.847a.429.429,0,0,0,.4.4l.649.1c.226.048.334-.049.314-.262Z",
    transform: "translate(4.597 3.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4846",
    "data-name": "Trazado 4846",
    d: "M1.135,1.4c.246.039.344-.068.315-.291L1.381.517A.415.415,0,0,0,.987.109L.338.012C.093-.036-.025.061,0,.293L.054.9a.411.411,0,0,0,.413.4Z",
    transform: "translate(4.732 5.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4847",
    "data-name": "Trazado 4847",
    d: "M.948.1.32.008C.074-.031-.024.076.005.318L.074.949a.433.433,0,0,0,.413.407l.648.068q.339.029.3-.32L1.341.483A.412.412,0,0,0,.948.1",
    transform: "translate(6.531 6.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4848",
    "data-name": "Trazado 4848",
    d: "M1.164,1.46c.246.039.364-.078.334-.311L1.429.5A.441.441,0,0,0,1.016.092L.358,0C.1-.024-.025.082,0,.315l.059.66A.43.43,0,0,0,.485,1.4Z",
    transform: "translate(4.871 6.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4849",
    "data-name": "Trazado 4849",
    d: "M1.046.073.368,0C.093-.024-.025.082,0,.354l.069.689a.4.4,0,0,0,.432.427l.7.058c.255.019.373-.106.344-.349L1.469.49A.436.436,0,0,0,1.046.073",
    transform: "translate(5.018 8.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4850",
    "data-name": "Trazado 4850",
    d: "M1.2.454A.4.4,0,0,0,.834.086L.293.008C.067-.031-.031.066.009.3l.1.6a.436.436,0,0,0,.4.378l.57.068c.2.02.285-.077.246-.3Z",
    transform: "translate(9.554 7.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4851",
    "data-name": "Trazado 4851",
    d: "M.88.095.3.008C.074-.031-.024.075.005.308L.094.93a.428.428,0,0,0,.4.388l.59.058c.236.029.324-.068.285-.3l-.1-.611A.4.4,0,0,0,.88.095",
    transform: "translate(8.093 7.049)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18530",
    "data-name": "Grupo 18530",
    transform: "translate(24.505 35.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18529",
    "data-name": "Grupo 18529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18528",
    "data-name": "Grupo 18528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18527",
    "data-name": "Grupo 18527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18526",
    "data-name": "Grupo 18526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18525",
    "data-name": "Grupo 18525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13096",
    "data-name": "Trazado 13096",
    d: "M401.715,263.507c.007-.038.522.052,1.359.116a15.675,15.675,0,0,0,6.444-.841c.792-.277,1.267-.5,1.283-.461.007.014-.1.083-.313.2a8.972,8.972,0,0,1-.912.42,13.28,13.28,0,0,1-6.518.85,8.9,8.9,0,0,1-.989-.172A1.125,1.125,0,0,1,401.715,263.507Z",
    transform: "translate(-401.715 -262.319)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18537",
    "data-name": "Grupo 18537",
    transform: "translate(24.783 35.935)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13098",
    "data-name": "Trazado 13098",
    d: "M402.275,263.962a4.8,4.8,0,0,0,4.49,2.087,4.34,4.34,0,0,0,3.641-2.958A15.93,15.93,0,0,1,402.275,263.962Z",
    transform: "translate(-402.275 -263.091)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18556",
    "data-name": "Grupo 18556",
    transform: "translate(0 0.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18549",
    "data-name": "Grupo 18549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18548",
    "data-name": "Grupo 18548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18547",
    "data-name": "Grupo 18547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18546",
    "data-name": "Grupo 18546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18545",
    "data-name": "Grupo 18545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13100",
    "data-name": "Trazado 13100",
    d: "M344.033,192.155s-6.306.772-8.754,6.16a94.546,94.546,0,0,0-4.237,11.825l12.861,2.9s2.023-10.88,2.178-14.72C346.249,194.109,346.414,192.034,344.033,192.155Z",
    transform: "translate(-331.042 -192.15)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18555",
    "data-name": "Grupo 18555",
    transform: "translate(11.669 15.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18554",
    "data-name": "Grupo 18554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18553",
    "data-name": "Grupo 18553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18552",
    "data-name": "Grupo 18552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18551",
    "data-name": "Grupo 18551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18550",
    "data-name": "Grupo 18550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13101",
    "data-name": "Trazado 13101",
    d: "M354.716,230.451a55.609,55.609,0,0,1,.015-7.215,55.841,55.841,0,0,1-.015,7.215Z",
    transform: "translate(-354.607 -223.236)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18769",
    "data-name": "Grupo 18769",
    transform: "translate(28.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18764",
    "data-name": "Grupo 18764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18558",
    "data-name": "Grupo 18558",
    transform: "translate(3.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13102",
    "data-name": "Trazado 13102",
    d: "M365.532,115.673a17.241,17.241,0,0,1,13.356-6.647c3.033-.051,4.289.58,6.473,1.17a9.576,9.576,0,0,1,5.459,3.611,16.055,16.055,0,0,1,3.141,7.329,45.02,45.02,0,0,1,.395,8.26,15.091,15.091,0,0,1-2.576,7.76l-7,1.217a44.03,44.03,0,0,1-11.56-.624c-3.769-.882-7.431-2.91-9.449-6.213C360.962,126.947,362.126,119.835,365.532,115.673Z",
    transform: "translate(-362.193 -109.023)",
    fill: "#1b202c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18561",
    "data-name": "Grupo 18561",
    transform: "translate(30.953 25.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18560",
    "data-name": "Grupo 18560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18559",
    "data-name": "Grupo 18559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13103",
    "data-name": "Trazado 13103",
    d: "M417.661,167.275c-.014.016.114.173.418.367a3.438,3.438,0,0,0,1.443.488,3.745,3.745,0,0,0,2.227-.452,3.737,3.737,0,0,0,1.348-4.985,3.746,3.746,0,0,0-1.7-1.512,3.439,3.439,0,0,0-1.492-.306,1.076,1.076,0,0,0-.546.106,5.235,5.235,0,0,1,1.91.466,3.609,3.609,0,0,1,1.488,1.435,3.441,3.441,0,0,1-1.207,4.464,3.61,3.61,0,0,1-2.008.489A5.222,5.222,0,0,1,417.661,167.275Z",
    transform: "translate(-417.66 -160.873)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18562",
    "data-name": "Grupo 18562",
    transform: "translate(0 22.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13104",
    "data-name": "Trazado 13104",
    d: "M355.187,158.953a5.228,5.228,0,0,1,2.371-3.943,3.765,3.765,0,0,1,4.422.383l1.1,1.312a4.521,4.521,0,0,1,2.6,4.56,4.954,4.954,0,0,1-3.435,4.053,5.485,5.485,0,0,1-5.222-1.261A6.149,6.149,0,0,1,355.187,158.953Z",
    transform: "translate(-355.151 -154.473)",
    fill: "#1b202c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18564",
    "data-name": "Grupo 18564",
    transform: "translate(0.805 24.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18563",
    "data-name": "Grupo 18563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13105",
    "data-name": "Trazado 13105",
    d: "M357.4,165.455a2.374,2.374,0,0,1-.377-1.394,6.33,6.33,0,0,1,1.6-3.149,9.475,9.475,0,0,1,2.807-2.251c.82-.441,1.385-.6,1.367-.659a3.828,3.828,0,0,0-1.474.441,8.441,8.441,0,0,0-2.962,2.247,8.3,8.3,0,0,0-1.132,1.722,3.783,3.783,0,0,0-.452,1.641,1.975,1.975,0,0,0,.314,1.111C357.248,165.391,357.383,165.47,357.4,165.455Z",
    transform: "translate(-356.776 -157.996)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18566",
    "data-name": "Grupo 18566",
    transform: "translate(4.473 24.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18565",
    "data-name": "Grupo 18565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13106",
    "data-name": "Trazado 13106",
    d: "M364.525,168.251a12.374,12.374,0,0,1,2.306-8.813,3.764,3.764,0,0,0-.925,1.04,9.75,9.75,0,0,0-1.678,6.413A3.765,3.765,0,0,0,364.525,168.251Z",
    transform: "translate(-364.184 -159.437)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18758",
    "data-name": "Grupo 18758",
    transform: "translate(6.486 2.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18757",
    "data-name": "Grupo 18757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18571",
    "data-name": "Grupo 18571",
    transform: "translate(3.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18570",
    "data-name": "Grupo 18570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18569",
    "data-name": "Grupo 18569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18568",
    "data-name": "Grupo 18568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18567",
    "data-name": "Grupo 18567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13107",
    "data-name": "Trazado 13107",
    d: "M391.732,152.687c-.047-2.458-.1-4.471-.1-4.46s5.712-.629,7.29-7.95c.785-3.641.931-9.673.891-14.612-.036-4.446-3.822-10.5-9.311-10.519l-2.44-.283-9.338,3.712a2.6,2.6,0,0,0-2.468,2.507l-.28,31.269L385,174.267l6.476-8.778Z",
    transform: "translate(-375.971 -114.864)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18572",
    "data-name": "Grupo 18572",
    transform: "translate(15.779 22.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13108",
    "data-name": "Trazado 13108",
    d: "M400.125,161.355a1.555,1.555,0,0,1,.539-.961,1.593,1.593,0,0,1,1.932-.11,2.133,2.133,0,0,1,.811,2h0a1.938,1.938,0,0,1-1.388.8,2.175,2.175,0,0,1-.26.008,1.741,1.741,0,0,1-1.174-.464A1.551,1.551,0,0,1,400.125,161.355Z",
    transform: "translate(-400.114 -160.009)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18724",
    "data-name": "Grupo 18724",
    transform: "translate(9.735 8.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18723",
    "data-name": "Grupo 18723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18722",
    "data-name": "Grupo 18722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18588",
    "data-name": "Grupo 18588",
    transform: "translate(12.401 6.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18587",
    "data-name": "Grupo 18587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18586",
    "data-name": "Grupo 18586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18585",
    "data-name": "Grupo 18585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18584",
    "data-name": "Grupo 18584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18583",
    "data-name": "Grupo 18583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18582",
    "data-name": "Grupo 18582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18581",
    "data-name": "Grupo 18581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18580",
    "data-name": "Grupo 18580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18579",
    "data-name": "Grupo 18579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18578",
    "data-name": "Grupo 18578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18577",
    "data-name": "Grupo 18577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18576",
    "data-name": "Grupo 18576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18575",
    "data-name": "Grupo 18575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18574",
    "data-name": "Grupo 18574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18573",
    "data-name": "Grupo 18573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13109",
    "data-name": "Trazado 13109",
    d: "M414.848,145.969a.949.949,0,0,1-.966.906.907.907,0,0,1-.929-.907.949.949,0,0,1,.965-.906A.908.908,0,0,1,414.848,145.969Z",
    transform: "translate(-412.953 -145.061)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18605",
    "data-name": "Grupo 18605",
    transform: "translate(12.368 3.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18604",
    "data-name": "Grupo 18604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18603",
    "data-name": "Grupo 18603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18602",
    "data-name": "Grupo 18602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18601",
    "data-name": "Grupo 18601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18600",
    "data-name": "Grupo 18600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18599",
    "data-name": "Grupo 18599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18598",
    "data-name": "Grupo 18598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18597",
    "data-name": "Grupo 18597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18596",
    "data-name": "Grupo 18596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18595",
    "data-name": "Grupo 18595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18594",
    "data-name": "Grupo 18594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18593",
    "data-name": "Grupo 18593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18592",
    "data-name": "Grupo 18592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18591",
    "data-name": "Grupo 18591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18590",
    "data-name": "Grupo 18590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18589",
    "data-name": "Grupo 18589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13110",
    "data-name": "Trazado 13110",
    d: "M416.627,141.093c-.124.117-.813-.453-1.832-.507s-1.794.415-1.9.284c-.052-.058.081-.274.419-.494a2.607,2.607,0,0,1,1.528-.381,2.5,2.5,0,0,1,1.45.558C416.594,140.811,416.688,141.041,416.627,141.093Z",
    transform: "translate(-412.886 -139.992)",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18621",
    "data-name": "Grupo 18621",
    transform: "translate(9.69 4.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18620",
    "data-name": "Grupo 18620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18619",
    "data-name": "Grupo 18619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18618",
    "data-name": "Grupo 18618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18617",
    "data-name": "Grupo 18617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18616",
    "data-name": "Grupo 18616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18615",
    "data-name": "Grupo 18615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18614",
    "data-name": "Grupo 18614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18613",
    "data-name": "Grupo 18613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18612",
    "data-name": "Grupo 18612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18611",
    "data-name": "Grupo 18611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18610",
    "data-name": "Grupo 18610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18609",
    "data-name": "Grupo 18609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18608",
    "data-name": "Grupo 18608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18607",
    "data-name": "Grupo 18607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18606",
    "data-name": "Grupo 18606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13111",
    "data-name": "Trazado 13111",
    d: "M407.491,149.125a6.79,6.79,0,0,1,1.672-.208c.262-.012.511-.051.564-.226a1.326,1.326,0,0,0-.131-.781q-.315-.965-.661-2.024a34.128,34.128,0,0,1-1.444-5.278,34.2,34.2,0,0,1,1.866,5.15c.219.71.428,1.386.627,2.034a1.508,1.508,0,0,1,.079,1.029.654.654,0,0,1-.449.357,1.743,1.743,0,0,1-.445.037A6.656,6.656,0,0,1,407.491,149.125Z",
    transform: "translate(-407.478 -140.607)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18636",
    "data-name": "Grupo 18636",
    transform: "translate(0 21.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18635",
    "data-name": "Grupo 18635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18634",
    "data-name": "Grupo 18634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18633",
    "data-name": "Grupo 18633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18632",
    "data-name": "Grupo 18632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18631",
    "data-name": "Grupo 18631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18630",
    "data-name": "Grupo 18630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18629",
    "data-name": "Grupo 18629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18628",
    "data-name": "Grupo 18628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18627",
    "data-name": "Grupo 18627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18626",
    "data-name": "Grupo 18626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18625",
    "data-name": "Grupo 18625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18624",
    "data-name": "Grupo 18624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18623",
    "data-name": "Grupo 18623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18622",
    "data-name": "Grupo 18622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13112",
    "data-name": "Trazado 13112",
    d: "M397.654,179a18.817,18.817,0,0,1-9.745-3.181s2.354,5.263,9.783,4.978Z",
    transform: "translate(-387.909 -175.818)",
    fill: "#e69972"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18652",
    "data-name": "Grupo 18652",
    transform: "translate(6.467 13.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18651",
    "data-name": "Grupo 18651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18650",
    "data-name": "Grupo 18650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18649",
    "data-name": "Grupo 18649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18648",
    "data-name": "Grupo 18648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18647",
    "data-name": "Grupo 18647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18646",
    "data-name": "Grupo 18646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18645",
    "data-name": "Grupo 18645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18644",
    "data-name": "Grupo 18644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18643",
    "data-name": "Grupo 18643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18642",
    "data-name": "Grupo 18642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18641",
    "data-name": "Grupo 18641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18640",
    "data-name": "Grupo 18640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18639",
    "data-name": "Grupo 18639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18638",
    "data-name": "Grupo 18638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18637",
    "data-name": "Grupo 18637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13113",
    "data-name": "Trazado 13113",
    d: "M401.168,158.9c.166,0,.108,1.106,1.012,1.943s2.088.78,2.088.935c.011.07-.274.2-.773.187a2.758,2.758,0,0,1-1.746-.718,2.4,2.4,0,0,1-.777-1.626C400.954,159.156,401.092,158.888,401.168,158.9Z",
    transform: "translate(-400.969 -158.898)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18670",
    "data-name": "Grupo 18670",
    transform: "translate(12.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18669",
    "data-name": "Grupo 18669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18668",
    "data-name": "Grupo 18668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18667",
    "data-name": "Grupo 18667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18666",
    "data-name": "Grupo 18666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18665",
    "data-name": "Grupo 18665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18664",
    "data-name": "Grupo 18664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18663",
    "data-name": "Grupo 18663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18662",
    "data-name": "Grupo 18662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18661",
    "data-name": "Grupo 18661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18660",
    "data-name": "Grupo 18660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18659",
    "data-name": "Grupo 18659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18658",
    "data-name": "Grupo 18658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18657",
    "data-name": "Grupo 18657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18656",
    "data-name": "Grupo 18656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18655",
    "data-name": "Grupo 18655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18654",
    "data-name": "Grupo 18654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18653",
    "data-name": "Grupo 18653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13114",
    "data-name": "Trazado 13114",
    d: "M416.186,133.458c-.185.239-.956.03-1.872.056-.917,0-1.685.224-1.873-.011-.083-.114.03-.351.359-.584a2.9,2.9,0,0,1,3.018-.037C416.152,133.108,416.267,133.341,416.186,133.458Z",
    transform: "translate(-412.415 -132.478)",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18686",
    "data-name": "Grupo 18686",
    transform: "translate(2.435 6.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18685",
    "data-name": "Grupo 18685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18684",
    "data-name": "Grupo 18684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18683",
    "data-name": "Grupo 18683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18682",
    "data-name": "Grupo 18682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18681",
    "data-name": "Grupo 18681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18680",
    "data-name": "Grupo 18680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18679",
    "data-name": "Grupo 18679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18678",
    "data-name": "Grupo 18678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18677",
    "data-name": "Grupo 18677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18676",
    "data-name": "Grupo 18676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18675",
    "data-name": "Grupo 18675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18674",
    "data-name": "Grupo 18674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18673",
    "data-name": "Grupo 18673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18672",
    "data-name": "Grupo 18672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18671",
    "data-name": "Grupo 18671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13115",
    "data-name": "Trazado 13115",
    d: "M392.828,145.492a.949.949,0,0,0,.9.973.907.907,0,0,0,.992-.838.949.949,0,0,0-.9-.973A.908.908,0,0,0,392.828,145.492Z",
    transform: "translate(-392.827 -144.651)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18703",
    "data-name": "Grupo 18703",
    transform: "translate(2.128 3.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18702",
    "data-name": "Grupo 18702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18701",
    "data-name": "Grupo 18701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18700",
    "data-name": "Grupo 18700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18699",
    "data-name": "Grupo 18699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18698",
    "data-name": "Grupo 18698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18697",
    "data-name": "Grupo 18697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18696",
    "data-name": "Grupo 18696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18695",
    "data-name": "Grupo 18695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18694",
    "data-name": "Grupo 18694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18693",
    "data-name": "Grupo 18693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18692",
    "data-name": "Grupo 18692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18691",
    "data-name": "Grupo 18691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18690",
    "data-name": "Grupo 18690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18689",
    "data-name": "Grupo 18689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18688",
    "data-name": "Grupo 18688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18687",
    "data-name": "Grupo 18687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13116",
    "data-name": "Trazado 13116",
    d: "M392.22,140.494c.115.126.843-.393,1.864-.373s1.759.544,1.872.421c.055-.054-.061-.28-.382-.523a2.606,2.606,0,0,0-1.5-.49,2.5,2.5,0,0,0-1.486.452C392.274,140.216,392.163,140.437,392.22,140.494Z",
    transform: "translate(-392.206 -139.529)",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18721",
    "data-name": "Grupo 18721",
    transform: "translate(1.528 1.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18720",
    "data-name": "Grupo 18720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18719",
    "data-name": "Grupo 18719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18718",
    "data-name": "Grupo 18718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18717",
    "data-name": "Grupo 18717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18716",
    "data-name": "Grupo 18716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18715",
    "data-name": "Grupo 18715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18714",
    "data-name": "Grupo 18714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18713",
    "data-name": "Grupo 18713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18712",
    "data-name": "Grupo 18712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18711",
    "data-name": "Grupo 18711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18710",
    "data-name": "Grupo 18710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18709",
    "data-name": "Grupo 18709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18708",
    "data-name": "Grupo 18708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18707",
    "data-name": "Grupo 18707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18706",
    "data-name": "Grupo 18706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18705",
    "data-name": "Grupo 18705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18704",
    "data-name": "Grupo 18704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13117",
    "data-name": "Trazado 13117",
    d: "M391.024,136.011c.2.235.988.008,1.935.013.947-.024,1.746.186,1.935-.053.083-.116-.039-.351-.386-.576a2.92,2.92,0,0,0-1.567-.408,2.888,2.888,0,0,0-1.551.439C391.051,135.659,390.937,135.9,391.024,136.011Z",
    transform: "translate(-390.996 -134.988)",
    fill: "#263238"
  })))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18756",
    "data-name": "Grupo 18756",
    transform: "translate(0 16.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18739",
    "data-name": "Grupo 18739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18738",
    "data-name": "Grupo 18738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18737",
    "data-name": "Grupo 18737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18736",
    "data-name": "Grupo 18736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18735",
    "data-name": "Grupo 18735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18734",
    "data-name": "Grupo 18734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18733",
    "data-name": "Grupo 18733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18732",
    "data-name": "Grupo 18732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18731",
    "data-name": "Grupo 18731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18730",
    "data-name": "Grupo 18730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18729",
    "data-name": "Grupo 18729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18728",
    "data-name": "Grupo 18728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18727",
    "data-name": "Grupo 18727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18726",
    "data-name": "Grupo 18726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18725",
    "data-name": "Grupo 18725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13118",
    "data-name": "Trazado 13118",
    d: "M373.622,150.323c.029-.55-.536-1.882-1.074-2-1.438-.306-4.059-.333-4.285,3.349-.31,5.033,4.808,4.306,4.825,4.162C373.1,155.726,373.522,152.222,373.622,150.323Z",
    transform: "translate(-368.249 -148.202)",
    fill: "#ffbe9d"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18755",
    "data-name": "Grupo 18755",
    transform: "translate(1.426 1.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18754",
    "data-name": "Grupo 18754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18753",
    "data-name": "Grupo 18753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18752",
    "data-name": "Grupo 18752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18751",
    "data-name": "Grupo 18751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18750",
    "data-name": "Grupo 18750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18749",
    "data-name": "Grupo 18749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18748",
    "data-name": "Grupo 18748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18747",
    "data-name": "Grupo 18747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18746",
    "data-name": "Grupo 18746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18745",
    "data-name": "Grupo 18745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18744",
    "data-name": "Grupo 18744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18743",
    "data-name": "Grupo 18743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18742",
    "data-name": "Grupo 18742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18741",
    "data-name": "Grupo 18741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18740",
    "data-name": "Grupo 18740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13119",
    "data-name": "Trazado 13119",
    d: "M373.266,155.617c-.021-.017-.092.056-.244.115a.878.878,0,0,1-.657-.027,2.173,2.173,0,0,1-.884-2.008,2.9,2.9,0,0,1,.322-1.24,1.015,1.015,0,0,1,.7-.632.448.448,0,0,1,.5.272c.059.145.021.244.047.254s.113-.078.085-.288a.558.558,0,0,0-.179-.328.66.66,0,0,0-.477-.158,1.235,1.235,0,0,0-.964.724,2.99,2.99,0,0,0-.39,1.384,2.28,2.28,0,0,0,1.146,2.253.939.939,0,0,0,.81-.084C373.25,155.738,373.283,155.627,373.266,155.617Z",
    transform: "translate(-371.129 -151.575)",
    fill: "#6f4c47"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18760",
    "data-name": "Grupo 18760",
    transform: "translate(7.904 2.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18759",
    "data-name": "Grupo 18759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13120",
    "data-name": "Trazado 13120",
    d: "M373.788,130.7l1.279,1.327c5.522-5.286,16.315-18.521,15.712-17.733a16.081,16.081,0,0,0-7.89-.857c-4.106.7-11.9,2.755-11.775,7.6A25.258,25.258,0,0,0,373.788,130.7Z",
    transform: "translate(-371.113 -113.256)",
    fill: "#1b202c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18763",
    "data-name": "Grupo 18763",
    transform: "translate(4.802 25.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18762",
    "data-name": "Grupo 18762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18761",
    "data-name": "Grupo 18761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13121",
    "data-name": "Trazado 13121",
    d: "M370.743,167.275c.014.016-.114.173-.418.367a3.438,3.438,0,0,1-1.443.488,3.745,3.745,0,0,1-2.227-.452,3.736,3.736,0,0,1-1.348-4.985,3.741,3.741,0,0,1,1.7-1.512,3.436,3.436,0,0,1,1.492-.306,1.075,1.075,0,0,1,.546.106,5.235,5.235,0,0,0-1.91.466,3.609,3.609,0,0,0-1.488,1.435,3.441,3.441,0,0,0,1.207,4.464,3.61,3.61,0,0,0,2.008.489A5.222,5.222,0,0,0,370.743,167.275Z",
    transform: "translate(-364.848 -160.873)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18766",
    "data-name": "Grupo 18766",
    transform: "translate(3.264 1.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18765",
    "data-name": "Grupo 18765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13122",
    "data-name": "Trazado 13122",
    d: "M361.743,129.464a1.3,1.3,0,0,1,.077-.292,5.12,5.12,0,0,1,.344-.793,7.317,7.317,0,0,1,2.1-2.367,13.749,13.749,0,0,1,4.235-2.037c1.684-.549,3.582-.975,5.444-1.774a24.662,24.662,0,0,0,4.973-2.785,25.719,25.719,0,0,0,3.51-3.069,27.343,27.343,0,0,0,2.03-2.409l.5-.694a1.356,1.356,0,0,1,.19-.234,1.321,1.321,0,0,1-.146.263c-.105.166-.254.416-.466.723a23.18,23.18,0,0,1-1.978,2.475,24.618,24.618,0,0,1-3.5,3.136,24.151,24.151,0,0,1-5.014,2.831,55.358,55.358,0,0,1-5.472,1.762,13.954,13.954,0,0,0-4.2,1.957,7.572,7.572,0,0,0-2.125,2.269C361.882,129.071,361.77,129.474,361.743,129.464Z",
    transform: "translate(-361.742 -113.011)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18768",
    "data-name": "Grupo 18768",
    transform: "translate(4.726 3.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18767",
    "data-name": "Grupo 18767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13123",
    "data-name": "Trazado 13123",
    d: "M364.7,131.356a2.646,2.646,0,0,1,.2-1.1,5.139,5.139,0,0,1,1.892-2.369,11.4,11.4,0,0,1,4.2-1.647,24.854,24.854,0,0,0,5.219-1.656,22.117,22.117,0,0,0,4.653-2.873,22.732,22.732,0,0,0,3.19-3.135,24.018,24.018,0,0,0,1.779-2.445l.426-.705a1.23,1.23,0,0,1,.164-.238,1.2,1.2,0,0,1-.119.263l-.386.731a20.534,20.534,0,0,1-1.724,2.509,21.663,21.663,0,0,1-7.877,6.127,24.251,24.251,0,0,1-5.273,1.653,11.492,11.492,0,0,0-4.148,1.564,5.2,5.2,0,0,0-1.9,2.257A5.914,5.914,0,0,0,364.7,131.356Z",
    transform: "translate(-364.695 -115.188)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18771",
    "data-name": "Grupo 18771",
    transform: "translate(1.869 42.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18770",
    "data-name": "Grupo 18770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13124",
    "data-name": "Trazado 13124",
    d: "M306.3,212.569c-.284-.105-.655-4.112-.655-4.112s-4-3.2-4.55-4.505a15.375,15.375,0,0,1-.465-4.405l6.559-4.467a60.154,60.154,0,0,1,4.894,4.831,13.9,13.9,0,0,1,1.287,4.57,17.769,17.769,0,0,1,.165,4.383l-.1,1.129S310.795,214.245,306.3,212.569Z",
    transform: "translate(-300.623 -195.08)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18798",
    "data-name": "Grupo 18798",
    transform: "translate(0 34.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18773",
    "data-name": "Grupo 18773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18772",
    "data-name": "Grupo 18772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13125",
    "data-name": "Trazado 13125",
    d: "M299.487,196.918a16.916,16.916,0,0,1-1.341-1.331c-.85-.92-1.8-1.782-1-2.757a1.416,1.416,0,0,1,1.027-.565s-.486-.857-.064-1.4a1.25,1.25,0,0,1,1.038-.48,2.249,2.249,0,0,1-.049-2.057,2.029,2.029,0,0,1,1.982-.78s-2.659-5.417-2.821-5.7c-.594-1.025-.539-2.143.651-2.266.436-.046.81.3,1.943,1.964s3.018,4.531,3.018,4.531,2.066,1.748,3.1,2.728a30.865,30.865,0,0,1,3.56,3.963,10.53,10.53,0,0,1,.728,4.64l-7.525,3.221S299.973,197.347,299.487,196.918Z",
    transform: "translate(-296.847 -179.584)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18776",
    "data-name": "Grupo 18776",
    transform: "translate(1.138 12.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18775",
    "data-name": "Grupo 18775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18774",
    "data-name": "Grupo 18774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13126",
    "data-name": "Trazado 13126",
    d: "M299.577,205.573a6.8,6.8,0,0,1,.895.616l.941.705a4.147,4.147,0,0,1,.539.459,1.252,1.252,0,0,1,.355.7.785.785,0,0,1-.28.744,1.023,1.023,0,0,1-.719.164,3.278,3.278,0,0,1-.628-.132c-.19-.054-.366-.108-.526-.161-.319-.1-.574-.2-.747-.274a.943.943,0,0,1-.262-.131c.009-.024.4.109,1.044.289a7.18,7.18,0,0,0,1.131.251.874.874,0,0,0,.6-.139.618.618,0,0,0,.212-.59,1.1,1.1,0,0,0-.309-.608,4.28,4.28,0,0,0-.512-.447l-.919-.735A6.788,6.788,0,0,1,299.577,205.573Z",
    transform: "translate(-299.145 -205.572)",
    fill: "#6f4c47"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18779",
    "data-name": "Grupo 18779",
    transform: "translate(7.731 8.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18778",
    "data-name": "Grupo 18778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18777",
    "data-name": "Grupo 18777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13127",
    "data-name": "Trazado 13127",
    d: "M312.844,199.761a3.8,3.8,0,0,1-.278-2.521c.051.005.014.574.093,1.266S312.891,199.745,312.844,199.761Z",
    transform: "translate(-312.46 -197.24)",
    fill: "#6f4c47"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18785",
    "data-name": "Grupo 18785",
    transform: "translate(3.96 11.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18781",
    "data-name": "Grupo 18781",
    transform: "translate(0.083 0.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18780",
    "data-name": "Grupo 18780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13128",
    "data-name": "Trazado 13128",
    d: "M312.726,202.961a5.419,5.419,0,0,0-3.055-.413,10.289,10.289,0,0,0-2.968.944c-.756.354-1.576.878-1.68,1.706a1.779,1.779,0,0,0,1.513,1.785,4.135,4.135,0,0,0,2.485-.493,10.53,10.53,0,0,1,2.379-.971",
    transform: "translate(-305.013 -202.49)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18784",
    "data-name": "Grupo 18784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18783",
    "data-name": "Grupo 18783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18782",
    "data-name": "Grupo 18782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13129",
    "data-name": "Trazado 13129",
    d: "M311.315,205.459c0,.014-.224.058-.612.2a17.119,17.119,0,0,0-1.59.751,7.462,7.462,0,0,1-1.136.465,3.326,3.326,0,0,1-1.412.142,2.112,2.112,0,0,1-1.366-.771,1.613,1.613,0,0,1-.344-.78,1.457,1.457,0,0,1,.167-.864,2.928,2.928,0,0,1,1.271-1.107,13.226,13.226,0,0,1,1.428-.615,7.863,7.863,0,0,1,2.577-.512,5.2,5.2,0,0,1,1.752.262,3.687,3.687,0,0,1,.446.183.647.647,0,0,1,.146.085c-.007.015-.214-.089-.612-.2a5.548,5.548,0,0,0-1.729-.2,8,8,0,0,0-2.525.539,13.638,13.638,0,0,0-1.4.616,2.8,2.8,0,0,0-1.2,1.038,1.29,1.29,0,0,0-.15.762,1.45,1.45,0,0,0,.306.7,1.964,1.964,0,0,0,1.256.719,3.219,3.219,0,0,0,1.35-.122,7.613,7.613,0,0,0,1.124-.438,13.663,13.663,0,0,1,1.621-.7,3.958,3.958,0,0,1,.467-.121A.6.6,0,0,1,311.315,205.459Z",
    transform: "translate(-304.845 -202.371)",
    fill: "#6f4c47"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18791",
    "data-name": "Grupo 18791",
    transform: "translate(1.657 11.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18787",
    "data-name": "Grupo 18787",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18786",
    "data-name": "Grupo 18786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13130",
    "data-name": "Trazado 13130",
    d: "M300.194,204.506c1.252.936,2.453,2.028,3.6,3.084a2.56,2.56,0,0,0,1.134.725c.357.075.962-.513,1.246-.741l-4.044-4.251",
    transform: "translate(-300.194 -203.325)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18790",
    "data-name": "Grupo 18790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18789",
    "data-name": "Grupo 18789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18788",
    "data-name": "Grupo 18788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13131",
    "data-name": "Trazado 13131",
    d: "M302.135,203.325a2.454,2.454,0,0,1,.333.306l.873.88c.736.752,1.755,1.808,2.9,3.006l.063.066-.071.058a8.655,8.655,0,0,1-.68.543,1.652,1.652,0,0,1-.321.173.639.639,0,0,1-.189.047.52.52,0,0,1-.2-.022,1.841,1.841,0,0,1-.62-.316c-.358-.276-.648-.577-.949-.846-.591-.546-1.128-1.032-1.586-1.432s-.835-.717-1.1-.934a3.44,3.44,0,0,1-.4-.348,2.813,2.813,0,0,1,.441.3c.275.2.666.5,1.134.894s1.016.868,1.614,1.408c.3.264.6.569.943.827a1.682,1.682,0,0,0,.564.287c.181.064.381-.056.568-.175.239-.16.451-.355.669-.533l-.008.125c-1.14-1.2-2.144-2.272-2.858-3.045l-.836-.916A2.42,2.42,0,0,1,302.135,203.325Z",
    transform: "translate(-300.193 -203.324)",
    fill: "#6f4c47"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18797",
    "data-name": "Grupo 18797",
    transform: "translate(2.457 8.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18793",
    "data-name": "Grupo 18793",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18792",
    "data-name": "Grupo 18792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13132",
    "data-name": "Trazado 13132",
    d: "M301.811,198.7l4.08,4.6a3.912,3.912,0,0,0,.964.869,1.323,1.323,0,0,0,1.247.081,1.354,1.354,0,0,0,.5-1.582,4.26,4.26,0,0,0-.989-1.485,36.085,36.085,0,0,1-3.349-4.471",
    transform: "translate(-301.811 -196.71)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18796",
    "data-name": "Grupo 18796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18795",
    "data-name": "Grupo 18795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18794",
    "data-name": "Grupo 18794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13133",
    "data-name": "Trazado 13133",
    d: "M304.268,196.71a.757.757,0,0,1,.113.144l.3.429c.259.372.636.909,1.125,1.555s1.09,1.4,1.8,2.2a5.545,5.545,0,0,1,1,1.375,1.763,1.763,0,0,1,.146.911,1.329,1.329,0,0,1-.416.863,1.149,1.149,0,0,1-.925.252,1.8,1.8,0,0,1-.847-.367,10.122,10.122,0,0,1-1.174-1.225l-1.878-2.144-1.255-1.455-.335-.4a.753.753,0,0,1-.108-.148.736.736,0,0,1,.134.125l.358.38,1.3,1.419,1.905,2.119a10.3,10.3,0,0,0,1.157,1.2,1.634,1.634,0,0,0,.768.333.981.981,0,0,0,.79-.212,1.165,1.165,0,0,0,.359-.752,1.6,1.6,0,0,0-.131-.826,5.486,5.486,0,0,0-.968-1.336c-.7-.813-1.3-1.578-1.776-2.235s-.84-1.206-1.082-1.59c-.12-.192-.212-.343-.272-.447A.716.716,0,0,1,304.268,196.71Z",
    transform: "translate(-301.81 -196.71)",
    fill: "#6f4c47"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18801",
    "data-name": "Grupo 18801",
    transform: "translate(8.234 52.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18800",
    "data-name": "Grupo 18800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18799",
    "data-name": "Grupo 18799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13134",
    "data-name": "Trazado 13134",
    d: "M316.38,216.774a.984.984,0,0,1-.483.106,2.74,2.74,0,0,1-2.154-.9c-.2-.233-.281-.408-.264-.418a3.492,3.492,0,0,0,2.9,1.212Z",
    transform: "translate(-313.477 -215.56)",
    fill: "#6f4c47"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18836",
    "data-name": "Grupo 18836",
    transform: "translate(49.225 39.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18806",
    "data-name": "Grupo 18806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18805",
    "data-name": "Grupo 18805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18804",
    "data-name": "Grupo 18804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18803",
    "data-name": "Grupo 18803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18802",
    "data-name": "Grupo 18802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13135",
    "data-name": "Trazado 13135",
    d: "M410.058,189.894l-1.425,17.995a1.175,1.175,0,0,1-1.247,1.079l-10.03-.651a1.175,1.175,0,0,1-1.094-1.279l1.639-17.981a1.175,1.175,0,0,1,1.246-1.066l9.816.638A1.175,1.175,0,0,1,410.058,189.894Z",
    transform: "translate(-396.257 -187.989)",
    fill: "#1b202c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18811",
    "data-name": "Grupo 18811",
    transform: "translate(14.809 24.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18810",
    "data-name": "Grupo 18810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18809",
    "data-name": "Grupo 18809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18808",
    "data-name": "Grupo 18808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18807",
    "data-name": "Grupo 18807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13136",
    "data-name": "Trazado 13136",
    d: "M439.509,238.1s3,20.244,2.878,22.964-3.193,8.752-7.333,9.343-8.042-3.193-8.16-8.16-.732-20.677-.732-20.677l3.089-1.7Z",
    transform: "translate(-426.163 -238.098)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18835",
    "data-name": "Grupo 18835",
    transform: "translate(2.752 8.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18816",
    "data-name": "Grupo 18816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18815",
    "data-name": "Grupo 18815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18814",
    "data-name": "Grupo 18814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18813",
    "data-name": "Grupo 18813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18812",
    "data-name": "Grupo 18812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13137",
    "data-name": "Trazado 13137",
    d: "M410.16,204.317s3.1,1.908,4.018,2.406.8,4.2.8,4.2l5.218,12.132L413.9,225.3a37.543,37.543,0,0,0-2.883-4.781,4.3,4.3,0,0,0-1.5-.751s-.322,1.18-1.288.644a9.384,9.384,0,0,1-2.039-1.824s-.859.536-1.181-.107-.859-2.039-.859-2.039,1.825-2.361,2.576-2.361,4.615.215,4.615.215a2.975,2.975,0,0,0-1.288-.752c-1.073-.429-7.464-2.309-7.765-2.425-.449-.174-.957-1.348.438-1.456s9.257,1.3,9.257,1.3.431-2.031.108-2.46S408.98,206.249,410.16,204.317Z",
    transform: "translate(-401.816 -204.317)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18822",
    "data-name": "Grupo 18822",
    transform: "translate(4.334 12.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18821",
    "data-name": "Grupo 18821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18820",
    "data-name": "Grupo 18820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18819",
    "data-name": "Grupo 18819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18818",
    "data-name": "Grupo 18818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18817",
    "data-name": "Grupo 18817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13138",
    "data-name": "Trazado 13138",
    d: "M410.6,230.786a2.01,2.01,0,0,1,.026-.883,1.579,1.579,0,0,1,.473-.868,1.825,1.825,0,0,1,1.153-.35,10.478,10.478,0,0,1,2.115.078,2.646,2.646,0,0,1,.854.2c-.01.072-1.328-.149-2.955-.043a1.7,1.7,0,0,0-1.028.281,1.5,1.5,0,0,0-.453.745C410.653,230.447,410.641,230.791,410.6,230.786Z",
    transform: "translate(-410.567 -228.663)",
    fill: "#ffbe9d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18828",
    "data-name": "Grupo 18828",
    transform: "translate(5.608 14.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18827",
    "data-name": "Grupo 18827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18826",
    "data-name": "Grupo 18826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18825",
    "data-name": "Grupo 18825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18824",
    "data-name": "Grupo 18824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18823",
    "data-name": "Grupo 18823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13139",
    "data-name": "Trazado 13139",
    d: "M413.142,233.727a22.8,22.8,0,0,0,2.444,1.066,3.4,3.4,0,0,1-2.444-1.066Z",
    transform: "translate(-413.14 -233.721)",
    fill: "#ffbe9d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18834",
    "data-name": "Grupo 18834",
    transform: "translate(9.808 6.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18833",
    "data-name": "Grupo 18833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18832",
    "data-name": "Grupo 18832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18831",
    "data-name": "Grupo 18831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18830",
    "data-name": "Grupo 18830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18829",
    "data-name": "Grupo 18829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13140",
    "data-name": "Trazado 13140",
    d: "M421.624,217.634a2.039,2.039,0,0,1,1.7,1.641c-.064.025-.278-.475-.749-.923S421.6,217.7,421.624,217.634Z",
    transform: "translate(-421.624 -217.619)",
    fill: "#ffbe9d"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18838",
    "data-name": "Grupo 18838",
    transform: "translate(8.205 111.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18837",
    "data-name": "Grupo 18837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13141",
    "data-name": "Trazado 13141",
    d: "M313.419,384.707c-.069-.017,2.635-11.386,6.039-25.391s6.221-25.35,6.29-25.333-2.634,11.384-6.04,25.394S313.488,384.724,313.419,384.707Z",
    transform: "translate(-313.417 -333.983)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(32.337 249.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18841",
    "data-name": "Grupo 18841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18840",
    "data-name": "Grupo 18840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13142",
    "data-name": "Trazado 13142",
    d: "M247.941,469.665c0,.071-47.241.129-105.5.129-58.282,0-105.514-.058-105.514-.129s47.232-.129,105.514-.129C200.7,469.536,247.941,469.594,247.941,469.665Z",
    transform: "translate(-36.923 -469.536)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(217.953 43.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18854",
    "data-name": "Grupo 18854",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18846",
    "data-name": "Grupo 18846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18845",
    "data-name": "Grupo 18845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18842",
    "data-name": "Grupo 18842",
    transform: "translate(0.089 0.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13143",
    "data-name": "Trazado 13143",
    d: "M412.668,81.059l1.456-5.255a14.675,14.675,0,1,1,3.515,3.911l0,.006Z",
    transform: "translate(-411.954 -53.477)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18844",
    "data-name": "Grupo 18844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18843",
    "data-name": "Grupo 18843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13144",
    "data-name": "Trazado 13144",
    d: "M412.577,80.937s.116-.036.332-.1l.956-.27,3.674-1.025-.03.09,0-.006a.057.057,0,0,1,.01-.08.059.059,0,0,1,.07,0,14.633,14.633,0,0,0,6.69,2.852,14.288,14.288,0,0,0,4.7-.06A14.606,14.606,0,0,0,440.755,70.9a14.842,14.842,0,0,0-.216-6.618,14.71,14.71,0,0,0-5.957-8.346,14.778,14.778,0,0,0-9.548-2.378,14.588,14.588,0,0,0-10.952,22.1.06.06,0,0,1,.006.047l-1.113,3.88-.293,1.01c-.067.228-.106.35-.106.35s.025-.107.083-.329l.263-1,1.053-3.943.006.046a14.669,14.669,0,0,1,.71-16.517,14.678,14.678,0,0,1,16.929-5.043,14.288,14.288,0,0,1,5.783,3.884,14.208,14.208,0,0,1,3.381,6.176A15.067,15.067,0,0,1,441,70.945,14.764,14.764,0,0,1,429,82.534a14.4,14.4,0,0,1-4.757.036,14.638,14.638,0,0,1-6.733-2.932l.08-.08,0,.006a.057.057,0,0,1-.01.079.059.059,0,0,1-.021.01l-3.734.967-.945.241C412.679,80.915,412.577,80.937,412.577,80.937Z",
    transform: "translate(-411.774 -53.236)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18853",
    "data-name": "Grupo 18853",
    transform: "translate(8.188 10.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18852",
    "data-name": "Grupo 18852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18851",
    "data-name": "Grupo 18851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18850",
    "data-name": "Grupo 18850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18849",
    "data-name": "Grupo 18849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18848",
    "data-name": "Grupo 18848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18847",
    "data-name": "Grupo 18847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13145",
    "data-name": "Trazado 13145",
    d: "M428.309,78.666l1.715-1.715,3.308,2.94,6.493-6.248,1.593,1.715-8.33,7.841Z",
    transform: "translate(-428.309 -73.643)",
    fill: "url(#linear-gradient)"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocCompleted);
export default __webpack_public_path__ + "static/media/docCompleted.e40da190c107eab04927af3d07733c31.svg";
export { ForwardRef as ReactComponent };